//--------------------------------------------------------------------------------
// Import jQuery
//--------------------------------------------------------------------------------

import jQuery from 'jquery';
export var $ = jQuery;

const urlParams = "fubon";
const q_id=new Date().getTime();
//--------------------------------------------------------------------------------
// Set $body
//--------------------------------------------------------------------------------

export var $body = null;
$(function() {
	$body = $("body");
});


//--------------------------------------------------------------------------------
// File: ./js/utils.js
//--------------------------------------------------------------------------------

export function getURLParameter(name) {
    name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
    var regexS = "[\\?&]"+name+"=([^&#]*)";
    var regex = new RegExp( regexS );
    var results = regex.exec( window.location.href );
    if( results == null )
        return "";
    else
        return results[1];
}

// A helper function to make a call-once-only delayed call
$.fn.delaycall = function(cid, fn, delaytime) {
    $(this).cleardelaycall(cid).each(function() {
        $(this).data("dct-"+cid, setTimeout(fn, delaytime));
    });
    return $(this);
};
$.fn.cleardelaycall = function(cid) {
    $(this).each(function() {
        var $this = $(this);
        var delaycalltimer = $this.data("dct-"+cid);
        if (delaycalltimer) {
            clearTimeout(delaycalltimer);
            $this.data("dct-"+cid, null);
        }
    });
    return $(this);
};

export var _IS_MSIE_OLD = false; // If true means msie7 or below, i.e. MSIE_OLD mode
export function isMSIE_OLD() {
    return _IS_MSIE_OLD;
}

export function isConflate() {
    var ic = false;
//    if (isMSIE_OLD() || isMSIE8() || ((report.gid)?($.inArray(report.gid, CONFLATE_WHITELIST) > -1):false)) {
//        ic = true;
//    }
    return ic;
}

//--------------------------------------------------------------------------------
// File: ./js/widget/abstractpageobj.js
//--------------------------------------------------------------------------------

export var AbstractPageObj = {

    // To extend, i.e. extending the AbstractPageObj, with specific {impl}, becoming a specific pageobj instance...
    // Usage: var YourPageObj = new AbstractPageObj.extend("yourpageobjdivid", { /* your custom implementation */ });
    extend: function(id, impl) {
        return $.extend(true, {}, AbstractPageObj, impl, {id: id});
    },

////////////////////////////////////////////////////////////////////////////////

    // Abstract implementation
    initImpl: function() {return this;}, // when this is initialized
    showImpl: function(statedata) {return this;}, // whenever this is to be shown in the view, with state retention by passing statedata (see also getStateDataImpl), or null if retenting the current state
    hideImpl: function() {return this;}, // whenever this is to be hidden in the view, with state retention
    refreshImpl: function() {return this;}, // when a refresh is required, with state retention
    resetImpl: function() {return this;}, // when wanting to clear any state retention

    // When the framework wants to extract the current state in this
    getStateDataImpl: function() {var statedata=null;return statedata;},

    // Implementation should override this to provide the specific set of resources to be used in this page
    PAGEOBJ_RESOURCEBUNDLE: {
        "ja": null,
        "en": null
    },

////////////////////////////////////////////////////////////////////////////////

    // Core functions that are used by the framework when manipulating a page
    initialized: false,

    id: null,
    $pageobj: null,
    pageobj_rb: null,

////////////////////////////////////////////////////////////////////////////////

    // A state to indicate that this is being initialized, hence to avoid double init() being triggered when initializing
    _initializing: false,

    init: function() {
        // Get ready...
//        var that = this;
        // To avoid double init() being triggered when initializing...
        if (this._initializing) {
//            // Being init? Wait a while and check again if this has been initialized
//            $main.delaycall("AbstractPageObj.init", function() {
//                that.init();
//            }, 500);

            // Noop~ Just return to avoid duplicate init() calls...
            return this;
        }

        this._initializing = true; // now start to initialize

        // Initialize for the first time, if not yet...
        if (!this.initialized) {
            // Update the initialization status
            //////CONSOLELOGGER.debug("[pageobj:"+this.id+"]: Initializing...");
            this.initialized = true;

            // Get the $object of the corresponding id of this page object
            this.$pageobj = $body.find(".workspacebox").find("#"+this.id);

            // Load the resources according to the app language
//            this.pageobj_rb = this.PAGEOBJ_RESOURCEBUNDLE[getAppLang()];

            // Show this page object hence for any dimension and visual access for initialization purpose
            this.$pageobj.show();

            // Call if any specific init() logic
            if (this.initImpl) this.initImpl();

            // Hide this page object after initialization
//            this.$pageobj.hide();

            //////CONSOLELOGGER.debug("[pageobj:"+this.id+"]: Initialized");
        }

        this._initializing = false; // finish :)

        // For chaining...
        return this;
    },

    show: function(statedata) {
        // Initialize this if not yet...
        if (!this.initialized) this.init();

        //////CONSOLELOGGER.debug("[pageobj:"+this.id+"]: About to show... statedata = " + JSON.stringify(statedata));

        // Show this page object
//        this.$pageobj.show();

        // Call if any specific show() logic
        if (this.showImpl) {
            var that = this;
            this.$pageobj.delaycall("show", function() {
                that.showImpl(statedata);
            }, 100);
        }

        //////CONSOLELOGGER.debug("[pageobj:"+this.id+"]: In view now");

        // Enable streaming now, since we are about to be shown ...
        this.holdStreaming(false);

        // For chaining...
        return this;
    },

    hide: function() {
        // No-op if not yet init
        if (!this.initialized) return this;
//        // Initialize this if not yet...
//        if (!this.initialized) this.init();

        // Hold streaming, since we are already in the process of hiding...
        this.holdStreaming(true);

        //////CONSOLELOGGER.debug("[pageobj:"+this.id+"]: About to hide...");

        // Logically hide this page object
        if (this.$pageobj.is(":visible")) {
            // Call if any specific hide() logic
            if (this.hideImpl) this.hideImpl();
            
            // Clear any chart auto-refresh process...
            this.$pageobj.find(".chartbox").stopautorefresh();

            //////CONSOLELOGGER.debug("[pageobj:"+this.id+"]: Now hidden, logically");
        }
//        else {
//            //////CONSOLELOGGER.debug("[pageobj:"+this.id+"]: Not visible, no need to hide, logically");
//        }

        // Now visually hide it
//        this.$pageobj.hide();

        // For chaining...
        return this;
    },

    refresh: function() {
        // No-op if not yet init
        if (!this.initialized) return this;
//        // Initialize this if not yet...
//        if (!this.initialized) this.init();

        //////CONSOLELOGGER.debug("[pageobj:"+this.id+"]: About to refresh...");

        // Call if any specific refresh() logic
        if (this.refreshImpl) this.refreshImpl();

        //////CONSOLELOGGER.debug("[pageobj:"+this.id+"]: Refreshed");

        // For chaining...
        return this;
    },

    reset: function() {
        // No-op if not yet init
        if (!this.initialized) return this;
//        // Initialize this if not yet...
//        if (!this.initialized) this.init();

        //////CONSOLELOGGER.debug("[pageobj:"+this.id+"]: About to reset...");

        // Call if any specific reset() logic
        if (this.resetImpl) this.resetImpl();

        //////CONSOLELOGGER.debug("[pageobj:"+this.id+"]: Reset finished");

        // For chaining...
        return this;
    },

    getStateData: function() {
        // No-op if not yet init
        if (!this.initialized) return this;
//        // Initialize this if not yet...
//        if (!this.initialized) this.init();

        //////CONSOLELOGGER.debug("[pageobj:"+this.id+"]: Getting the current state data...");

        // Call if any specific getStateData() logic
        var statedata = null;
        if (this.getStateDataImpl) statedata = this.getStateDataImpl();

        //////CONSOLELOGGER.debug("[pageobj:"+this.id+"]: Finished getting the current state data");

        // Done
        return statedata;
    },

////////////////////////////////////////////////////////////////////////////////

    // Temporary hold any streaming update to avoid overloading the UI (only for MSIE?!)
    _holdstreaming: true,
    holdStreaming: function(hold) {
//        if (isMSIE()) {
            this._holdstreaming = hold;
//        }
    },

    // If registered for streaming, this standard method helps to distribute the
    // streaming data in this $pageobj
    stream: function(data) {
        if (!this._holdstreaming)
//            if (this.$pageobj.is(":visible")) // ... when this page is not visible (i.e. when hide()), _holdstreaming would have been set (called holdStreaming(true))
                Streaming.stream(this, data);
    },
    
    connStatusChange: function(status) {
        return this;
    }
    
};



//--------------------------------------------------------------------------------
// File: ./js/util/financialdataformat.js
//--------------------------------------------------------------------------------

// Default for JPN
export var FORMATPATTERN_TRADE_DATE_LONGYMD = "yyyy/MM/dd";
//export var FORMATPATTERN_TRADE_DATE_SHORTYMD = "yy/MM/dd";
export var FORMATPATTERN_TRADE_DATE_MD = "MM/dd";
//export var FORMATPATTERN_TRADE_DATE_YM = "yy/MM";
export var FORMMTPATTERN_TRADE_DATE_LONGYM = "yyyy/MM";

//export var FORMATPATTERN_DATETIME_LONGYMD = "yyyy/MM/dd HH:mm";
//export var FORMATPATTERN_DATETIME_SHORTYMD = "yy/MM/dd HH:mm";
//export var FORMATPATTERN_DATETIME_MD = "MM/dd HH:mm";
export var FORMATPATTERN_SALTIME_MD="HH:mm";



//--------------------------------------------------------------------------------
// File: ./js/util/numberformat.js
//--------------------------------------------------------------------------------

// mredkj.com
/*
export function NumberFormat(num, inputDecimal)
{
this.VERSION = 'Number Format v1.5.4c';
this.COMMA = ',';
this.PERIOD = '.';
this.DASH = '-'; 
this.LEFT_PAREN = '('; 
this.RIGHT_PAREN = ')'; 
this.LEFT_OUTSIDE = 0; 
this.LEFT_INSIDE = 1;  
this.RIGHT_INSIDE = 2;  
this.RIGHT_OUTSIDE = 3;  
this.LEFT_DASH = 0; 
this.RIGHT_DASH = 1; 
this.PARENTHESIS = 2; 
this.NO_ROUNDING = -1 
this.num;
this.numOriginal;
this.hasSeparators = false;  
this.separatorValue;  
this.inputDecimalValue; 
this.decimalValue;  
this.negativeFormat; 
this.negativeRed; 
this.hasCurrency;  
this.currencyPosition;  
this.currencyValue;  
this.places;
this.roundToPlaces; 
this.truncate; 
this.positiveSign;
this.percentage;
this.setNumber = setNumberNF;
this.toUnformatted = toUnformattedNF;
this.setInputDecimal = setInputDecimalNF; 
this.setSeparators = setSeparatorsNF; 
this.setCommas = setCommasNF;
this.setNegativeFormat = setNegativeFormatNF; 
this.setNegativeRed = setNegativeRedNF; 
this.setCurrency = setCurrencyNF;
this.setCurrencyPrefix = setCurrencyPrefixNF;
this.setCurrencyValue = setCurrencyValueNF; 
this.setCurrencyPosition = setCurrencyPositionNF; 
this.setPlaces = setPlacesNF;
this.toFormatted = toFormattedNF;
this.toPercentage = toPercentageNF;
this.getOriginal = getOriginalNF;
this.moveDecimalRight = moveDecimalRightNF;
this.moveDecimalLeft = moveDecimalLeftNF;
this.getRounded = getRoundedNF;
this.preserveZeros = preserveZerosNF;
this.justNumber = justNumberNF;
this.expandExponential = expandExponentialNF;
this.getZeros = getZerosNF;
this.moveDecimalAsString = moveDecimalAsStringNF;
this.moveDecimal = moveDecimalNF;
this.addSeparators = addSeparatorsNF;
this.setPositiveSign = setPositiveSignNF;
this.setPercentage = setPercentageNF;
if (inputDecimal == null) {
this.setNumber(num, this.PERIOD);
} else {
this.setNumber(num, inputDecimal); 
}
this.setCommas(true);
this.setNegativeFormat(this.LEFT_DASH); 
this.setNegativeRed(false);
this.setCurrency(false); 
this.setCurrencyPrefix('$');
this.setPlaces(this.NO_ROUNDING);
this.setPositiveSign(false);
this.setPercentage(false);
}
export function setInputDecimalNF(val)
{
this.inputDecimalValue = val;
}
export function setNumberNF(num, inputDecimal)
{
if (inputDecimal != null) {
this.setInputDecimal(inputDecimal); 
}
this.numOriginal = num;
this.num = this.justNumber(num);
}
export function toUnformattedNF()
{
return (this.num);
}
export function getOriginalNF()
{
return (this.numOriginal);
}
export function setNegativeFormatNF(format)
{
this.negativeFormat = format;
}
export function setNegativeRedNF(isRed)
{
this.negativeRed = isRed;
}
export function setSeparatorsNF(isC, separator, decimal)
{
this.hasSeparators = isC;
if (separator == null) separator = this.COMMA;
if (decimal == null) decimal = this.PERIOD;
if (separator == decimal) {
this.decimalValue = (decimal == this.PERIOD) ? this.COMMA : this.PERIOD;
} else {
this.decimalValue = decimal;
}
this.separatorValue = separator;
}
export function setCommasNF(isC)
{
this.setSeparators(isC, this.COMMA, this.PERIOD);
}
export function setCurrencyNF(isC)
{
this.hasCurrency = isC;
}
export function setCurrencyValueNF(val)
{
this.currencyValue = val;
}
export function setCurrencyPrefixNF(cp)
{
this.setCurrencyValue(cp);
this.setCurrencyPosition(this.LEFT_OUTSIDE);
}
export function setCurrencyPositionNF(cp)
{
this.currencyPosition = cp
}
export function setPlacesNF(p, tr)
{
this.roundToPlaces = !(p == this.NO_ROUNDING); 
this.truncate = (tr != null && tr); 
this.places = (p < 0) ? 0 : p; 
}
export function addSeparatorsNF(nStr, inD, outD, sep)
{
nStr += '';
var dpos = nStr.indexOf(inD);
var nStrEnd = '';
if (dpos != -1) {
nStrEnd = outD + nStr.substring(dpos + 1, nStr.length);
nStr = nStr.substring(0, dpos);
}
var rgx = /(\d+)(\d{3})/;
while (rgx.test(nStr)) {
nStr = nStr.replace(rgx, '$1' + sep + '$2');
}
return nStr + nStrEnd;
}
export function toFormattedNF()
{	
var pos;
var nNum = this.num; 
var nStr;          
var len;
var i;
var splitString = new Array(2);   
if (this.roundToPlaces) {
nNum = this.getRounded(nNum);
nStr = this.preserveZeros(Math.abs(nNum)); 
} else {
nStr = this.expandExponential(Math.abs(nNum));
len = (nNum+'').length;
if (this.numOriginal.indexOf('.')>-1 && nStr.indexOf('.')<0) {
nStr += '.';
len++;
}
if (nNum==0 && this.numOriginal.indexOf("-")==0) { //for -0.00 case
len++;
}
for (i=0; i<(this.numOriginal.length-len); i++) {
nStr += '0';
}
}
if (this.hasSeparators) {
nStr = this.addSeparators(nStr, this.PERIOD, this.decimalValue, this.separatorValue);
} else {
nStr = nStr.replace(new RegExp('\\' + this.PERIOD), this.decimalValue); 
}
var c0 = '';
var n0 = '';
var c1 = '';
var n1 = '';
var n2 = '';
var c2 = '';
var n3 = '';
var c3 = '';
var p0 = '';
var negSignL = (this.negativeFormat == this.PARENTHESIS) ? this.LEFT_PAREN : this.DASH;
var negSignR = (this.negativeFormat == this.PARENTHESIS) ? this.RIGHT_PAREN : this.DASH;
if (this.currencyPosition == this.LEFT_OUTSIDE) {
if (nNum < 0) {
if (this.negativeFormat == this.LEFT_DASH || this.negativeFormat == this.PARENTHESIS) n1 = negSignL;
if (this.negativeFormat == this.RIGHT_DASH || this.negativeFormat == this.PARENTHESIS) n2 = negSignR;
}
if (this.hasCurrency) c0 = this.currencyValue;
} else if (this.currencyPosition == this.LEFT_INSIDE) {
if (nNum < 0) {
if (this.negativeFormat == this.LEFT_DASH || this.negativeFormat == this.PARENTHESIS) n0 = negSignL;
if (this.negativeFormat == this.RIGHT_DASH || this.negativeFormat == this.PARENTHESIS) n3 = negSignR;
}
if (this.hasCurrency) c1 = this.currencyValue;
}
else if (this.currencyPosition == this.RIGHT_INSIDE) {
if (nNum < 0) {
if (this.negativeFormat == this.LEFT_DASH || this.negativeFormat == this.PARENTHESIS) n0 = negSignL;
if (this.negativeFormat == this.RIGHT_DASH || this.negativeFormat == this.PARENTHESIS) n3 = negSignR;
}
if (this.hasCurrency) c2 = this.currencyValue;
}
else if (this.currencyPosition == this.RIGHT_OUTSIDE) {
if (nNum < 0) {
if (this.negativeFormat == this.LEFT_DASH || this.negativeFormat == this.PARENTHESIS) n1 = negSignL;
if (this.negativeFormat == this.RIGHT_DASH || this.negativeFormat == this.PARENTHESIS) n2 = negSignR;
}
if (this.hasCurrency) c3 = this.currencyValue;
}
if (this.percentage) {
if (nStr.indexOf("%")!=nStr.length-1) {
  p0 = '%';
}
}
nStr = c0 + n0 + c1 + n1 + nStr + p0 + n2 + c2 + n3 + c3;
if (this.negativeRed && nNum < 0) {
nStr = '<font color="red">' + nStr + '</font>';
}
if (this.positiveSign && nNum > 0) {
nStr = '+' + nStr;
}
return (nStr);
}
export function toPercentageNF()
{
nNum = this.num * 100;
nNum = this.getRounded(nNum);
return nNum + '%';
}
export function getZerosNF(places)
{
var extraZ = '';
var i;
for (i=0; i<places; i++) {
extraZ += '0';
}
return extraZ;
}
export function expandExponentialNF(origVal)
{
if (isNaN(origVal)) return origVal;
var newVal = parseFloat(origVal) + ''; 
var eLoc = newVal.toLowerCase().indexOf('e');
if (eLoc != -1) {
var plusLoc = newVal.toLowerCase().indexOf('+');
var negLoc = newVal.toLowerCase().indexOf('-', eLoc); 
var justNumber = newVal.substring(0, eLoc);
if (negLoc != -1) {
var places = newVal.substring(negLoc + 1, newVal.length);
justNumber = this.moveDecimalAsString(justNumber, true, parseInt(places));
} else {
if (plusLoc == -1) plusLoc = eLoc;
var places = newVal.substring(plusLoc + 1, newVal.length);
justNumber = this.moveDecimalAsString(justNumber, false, parseInt(places));
}
newVal = justNumber;
}
return newVal;
} 
export function moveDecimalRightNF(val, places)
{
var newVal = '';
if (places == null) {
newVal = this.moveDecimal(val, false);
} else {
newVal = this.moveDecimal(val, false, places);
}
return newVal;
}
export function moveDecimalLeftNF(val, places)
{
var newVal = '';
if (places == null) {
newVal = this.moveDecimal(val, true);
} else {
newVal = this.moveDecimal(val, true, places);
}
return newVal;
}
export function moveDecimalAsStringNF(val, left, places)
{
var spaces = (arguments.length < 3) ? this.places : places;
if (spaces <= 0) return val; 
var newVal = val + '';
var extraZ = this.getZeros(spaces);
var re1 = new RegExp('([0-9.]+)');
if (left) {
newVal = newVal.replace(re1, extraZ + '$1');
var re2 = new RegExp('(-?)([0-9]*)([0-9]{' + spaces + '})(\\.?)');		
newVal = newVal.replace(re2, '$1$2.$3');
} else {
var reArray = re1.exec(newVal); 
if (reArray != null) {
newVal = newVal.substring(0,reArray.index) + reArray[1] + extraZ + newVal.substring(reArray.index + reArray[0].length); 
}
var re2 = new RegExp('(-?)([0-9]*)(\\.?)([0-9]{' + spaces + '})');
newVal = newVal.replace(re2, '$1$2$4.');
}
newVal = newVal.replace(/\.$/, ''); 
return newVal;
}
export function moveDecimalNF(val, left, places)
{
var newVal = '';
if (places == null) {
newVal = this.moveDecimalAsString(val, left);
} else {
newVal = this.moveDecimalAsString(val, left, places);
}
return parseFloat(newVal);
}
export function getRoundedNF(val)
{
val = this.moveDecimalRight(val);
if (this.truncate) {
val = val >= 0 ? Math.floor(val) : Math.ceil(val); 
} else {
val = Math.round(val);
}
val = this.moveDecimalLeft(val);
return val;
}
export function preserveZerosNF(val)
{
var i;
val = this.expandExponential(val);
if (this.places <= 0) return val; 
var decimalPos = val.indexOf('.');
if (decimalPos == -1) {
val += '.';
for (i=0; i<this.places; i++) {
val += '0';
}
} else {
var actualDecimals = (val.length - 1) - decimalPos;
var difference = this.places - actualDecimals;
for (i=0; i<difference; i++) {
val += '0';
}
}
return val;
}
export function justNumberNF(val)
{
newVal = val + '';
var isPercentage = false;
if (newVal.indexOf('%') != -1) {
newVal = newVal.replace(/\%/g, '');
isPercentage = true; 
}
var re = new RegExp('[^\\' + this.inputDecimalValue + '\\d\\-\\+\\(\\)eE]', 'g');	
newVal = newVal.replace(re, '');
var tempRe = new RegExp('[' + this.inputDecimalValue + ']', 'g');
var treArray = tempRe.exec(newVal); 
if (treArray != null) {
var tempRight = newVal.substring(treArray.index + treArray[0].length); 
newVal = newVal.substring(0,treArray.index) + this.PERIOD + tempRight.replace(tempRe, ''); 
}
if (newVal.charAt(newVal.length - 1) == this.DASH ) {
newVal = newVal.substring(0, newVal.length - 1);
newVal = '-' + newVal;
}
else if (newVal.charAt(0) == this.LEFT_PAREN
&& newVal.charAt(newVal.length - 1) == this.RIGHT_PAREN) {
newVal = newVal.substring(1, newVal.length - 1);
newVal = '-' + newVal;
}
newVal = parseFloat(newVal);
if (!isFinite(newVal)) {
newVal = 0;
}
if (isPercentage) {
newVal = this.moveDecimalLeft(newVal, 2);
}
return newVal;
}
export function setPositiveSignNF(isPositiveSign)
{
this.positiveSign = isPositiveSign;
}
export function setPercentageNF(isPercentage)
{
this.percentage = isPercentage;
}
*/


//--------------------------------------------------------------------------------
// File: ./js/util/date.js
//--------------------------------------------------------------------------------

/**
 * @version: 1.0 Alpha-1
 * @author: Coolite Inc. http://www.coolite.com/
 * @date: 2008-05-13
 * @copyright: Copyright (c) 2006-2008, Coolite Inc. (http://www.coolite.com/). All rights reserved.
 * @license: Licensed under The MIT License. See license.txt and http://www.datejs.com/license/. 
 * @website: http://www.datejs.com/
 */
Date.CultureInfo={name:"en-US",englishName:"English (United States)",nativeName:"English (United States)",dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],abbreviatedDayNames:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],shortestDayNames:["Su","Mo","Tu","We","Th","Fr","Sa"],firstLetterDayNames:["S","M","T","W","T","F","S"],monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],abbreviatedMonthNames:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],amDesignator:"AM",pmDesignator:"PM",firstDayOfWeek:0,twoDigitYearMax:2029,dateElementOrder:"mdy",formatPatterns:{shortDate:"M/d/yyyy",longDate:"dddd, MMMM dd, yyyy",shortTime:"h:mm tt",longTime:"h:mm:ss tt",fullDateTime:"dddd, MMMM dd, yyyy h:mm:ss tt",sortableDateTime:"yyyy-MM-ddTHH:mm:ss",universalSortableDateTime:"yyyy-MM-dd HH:mm:ssZ",rfc1123:"ddd, dd MMM yyyy HH:mm:ss GMT",monthDay:"MMMM dd",yearMonth:"MMMM, yyyy"},regexPatterns:{jan:/^jan(uary)?/i,feb:/^feb(ruary)?/i,mar:/^mar(ch)?/i,apr:/^apr(il)?/i,may:/^may/i,jun:/^jun(e)?/i,jul:/^jul(y)?/i,aug:/^aug(ust)?/i,sep:/^sep(t(ember)?)?/i,oct:/^oct(ober)?/i,nov:/^nov(ember)?/i,dec:/^dec(ember)?/i,sun:/^su(n(day)?)?/i,mon:/^mo(n(day)?)?/i,tue:/^tu(e(s(day)?)?)?/i,wed:/^we(d(nesday)?)?/i,thu:/^th(u(r(s(day)?)?)?)?/i,fri:/^fr(i(day)?)?/i,sat:/^sa(t(urday)?)?/i,future:/^next/i,past:/^last|past|prev(ious)?/i,add:/^(\+|aft(er)?|from|hence)/i,subtract:/^(\-|bef(ore)?|ago)/i,yesterday:/^yes(terday)?/i,today:/^t(od(ay)?)?/i,tomorrow:/^tom(orrow)?/i,now:/^n(ow)?/i,millisecond:/^ms|milli(second)?s?/i,second:/^sec(ond)?s?/i,minute:/^mn|min(ute)?s?/i,hour:/^h(our)?s?/i,week:/^w(eek)?s?/i,month:/^m(onth)?s?/i,day:/^d(ay)?s?/i,year:/^y(ear)?s?/i,shortMeridian:/^(a|p)/i,longMeridian:/^(a\.?m?\.?|p\.?m?\.?)/i,timezone:/^((e(s|d)t|c(s|d)t|m(s|d)t|p(s|d)t)|((gmt)?\s*(\+|\-)\s*\d\d\d\d?)|gmt|utc)/i,ordinalSuffix:/^\s*(st|nd|rd|th)/i,timeContext:/^\s*(\:|a(?!u|p)|p)/i},timezones:[{name:"UTC",offset:"-000"},{name:"GMT",offset:"-000"},{name:"EST",offset:"-0500"},{name:"EDT",offset:"-0400"},{name:"CST",offset:"-0600"},{name:"CDT",offset:"-0500"},{name:"MST",offset:"-0700"},{name:"MDT",offset:"-0600"},{name:"PST",offset:"-0800"},{name:"PDT",offset:"-0700"}]};
(function(){var $D=Date,$P=$D.prototype,$C=$D.CultureInfo,p=function(s,l){if(!l){l=2;}
return("000"+s).slice(l*-1);};$P.clearTime=function(){this.setHours(0);this.setMinutes(0);this.setSeconds(0);this.setMilliseconds(0);return this;};$P.setTimeToNow=function(){var n=new Date();this.setHours(n.getHours());this.setMinutes(n.getMinutes());this.setSeconds(n.getSeconds());this.setMilliseconds(n.getMilliseconds());return this;};$D.today=function(){return new Date().clearTime();};$D.compare=function(date1,date2){if(isNaN(date1)||isNaN(date2)){throw new Error(date1+" - "+date2);}else if(date1 instanceof Date&&date2 instanceof Date){return(date1<date2)?-1:(date1>date2)?1:0;}else{throw new TypeError(date1+" - "+date2);}};$D.equals=function(date1,date2){return(date1.compareTo(date2)===0);};$D.getDayNumberFromName=function(name){var n=$C.dayNames,m=$C.abbreviatedDayNames,o=$C.shortestDayNames,s=name.toLowerCase();for(var i=0;i<n.length;i++){if(n[i].toLowerCase()==s||m[i].toLowerCase()==s||o[i].toLowerCase()==s){return i;}}
return-1;};$D.getMonthNumberFromName=function(name){var n=$C.monthNames,m=$C.abbreviatedMonthNames,s=name.toLowerCase();for(var i=0;i<n.length;i++){if(n[i].toLowerCase()==s||m[i].toLowerCase()==s){return i;}}
return-1;};$D.isLeapYear=function(year){return((year%4===0&&year%100!==0)||year%400===0);};$D.getDaysInMonth=function(year,month){return[31,($D.isLeapYear(year)?29:28),31,30,31,30,31,31,30,31,30,31][month];};$D.getTimezoneAbbreviation=function(offset){var z=$C.timezones,p;for(var i=0;i<z.length;i++){if(z[i].offset===offset){return z[i].name;}}
return null;};$D.getTimezoneOffset=function(name){var z=$C.timezones,p;for(var i=0;i<z.length;i++){if(z[i].name===name.toUpperCase()){return z[i].offset;}}
return null;};$P.clone=function(){return new Date(this.getTime());};$P.compareTo=function(date){return Date.compare(this,date);};$P.equals=function(date){return Date.equals(this,date||new Date());};$P.between=function(start,end){return this.getTime()>=start.getTime()&&this.getTime()<=end.getTime();};$P.isAfter=function(date){return this.compareTo(date||new Date())===1;};$P.isBefore=function(date){return(this.compareTo(date||new Date())===-1);};$P.isToday=function(){return this.isSameDay(new Date());};$P.isSameDay=function(date){return this.clone().clearTime().equals(date.clone().clearTime());};$P.addMilliseconds=function(value){this.setMilliseconds(this.getMilliseconds()+value);return this;};$P.addSeconds=function(value){return this.addMilliseconds(value*1000);};$P.addMinutes=function(value){return this.addMilliseconds(value*60000);};$P.addHours=function(value){return this.addMilliseconds(value*3600000);};$P.addDays=function(value){this.setDate(this.getDate()+value);return this;};$P.addWeeks=function(value){return this.addDays(value*7);};$P.addMonths=function(value){var n=this.getDate();this.setDate(1);this.setMonth(this.getMonth()+value);this.setDate(Math.min(n,$D.getDaysInMonth(this.getFullYear(),this.getMonth())));return this;};$P.addYears=function(value){return this.addMonths(value*12);};$P.add=function(config){if(typeof config=="number"){this._orient=config;return this;}
var x=config;if(x.milliseconds){this.addMilliseconds(x.milliseconds);}
if(x.seconds){this.addSeconds(x.seconds);}
if(x.minutes){this.addMinutes(x.minutes);}
if(x.hours){this.addHours(x.hours);}
if(x.weeks){this.addWeeks(x.weeks);}
if(x.months){this.addMonths(x.months);}
if(x.years){this.addYears(x.years);}
if(x.days){this.addDays(x.days);}
return this;};var $y,$m,$d;$P.getWeek=function(){var a,b,c,d,e,f,g,n,s,w;$y=(!$y)?this.getFullYear():$y;$m=(!$m)?this.getMonth()+1:$m;$d=(!$d)?this.getDate():$d;if($m<=2){a=$y-1;b=(a/4|0)-(a/100|0)+(a/400|0);c=((a-1)/4|0)-((a-1)/100|0)+((a-1)/400|0);s=b-c;e=0;f=$d-1+(31*($m-1));}else{a=$y;b=(a/4|0)-(a/100|0)+(a/400|0);c=((a-1)/4|0)-((a-1)/100|0)+((a-1)/400|0);s=b-c;e=s+1;f=$d+((153*($m-3)+2)/5)+58+s;}
g=(a+b)%7;d=(f+g-e)%7;n=(f+3-d)|0;if(n<0){w=53-((g-s)/5|0);}else if(n>364+s){w=1;}else{w=(n/7|0)+1;}
$y=$m=$d=null;return w;};$P.getISOWeek=function(){$y=this.getUTCFullYear();$m=this.getUTCMonth()+1;$d=this.getUTCDate();return p(this.getWeek());};$P.setWeek=function(n){return this.moveToDayOfWeek(1).addWeeks(n-this.getWeek());};$D._validate=function(n,min,max,name){if(typeof n=="undefined"){return false;}else if(typeof n!="number"){throw new TypeError(n+" is not a Number.");}else if(n<min||n>max){throw new RangeError(n+" is not a valid value for "+name+".");}
return true;};$D.validateMillisecond=function(value){return $D._validate(value,0,999,"millisecond");};$D.validateSecond=function(value){return $D._validate(value,0,59,"second");};$D.validateMinute=function(value){return $D._validate(value,0,59,"minute");};$D.validateHour=function(value){return $D._validate(value,0,23,"hour");};$D.validateDay=function(value,year,month){return $D._validate(value,1,$D.getDaysInMonth(year,month),"day");};$D.validateMonth=function(value){return $D._validate(value,0,11,"month");};$D.validateYear=function(value){return $D._validate(value,0,9999,"year");};$P.set=function(config){if($D.validateMillisecond(config.millisecond)){this.addMilliseconds(config.millisecond-this.getMilliseconds());}
if($D.validateSecond(config.second)){this.addSeconds(config.second-this.getSeconds());}
if($D.validateMinute(config.minute)){this.addMinutes(config.minute-this.getMinutes());}
if($D.validateHour(config.hour)){this.addHours(config.hour-this.getHours());}
if($D.validateMonth(config.month)){this.addMonths(config.month-this.getMonth());}
if($D.validateYear(config.year)){this.addYears(config.year-this.getFullYear());}
if($D.validateDay(config.day,this.getFullYear(),this.getMonth())){this.addDays(config.day-this.getDate());}
if(config.timezone){this.setTimezone(config.timezone);}
if(config.timezoneOffset){this.setTimezoneOffset(config.timezoneOffset);}
if(config.week&&$D._validate(config.week,0,53,"week")){this.setWeek(config.week);}
return this;};$P.moveToFirstDayOfMonth=function(){return this.set({day:1});};$P.moveToLastDayOfMonth=function(){return this.set({day:$D.getDaysInMonth(this.getFullYear(),this.getMonth())});};$P.moveToNthOccurrence=function(dayOfWeek,occurrence){var shift=0;if(occurrence>0){shift=occurrence-1;}
else if(occurrence===-1){this.moveToLastDayOfMonth();if(this.getDay()!==dayOfWeek){this.moveToDayOfWeek(dayOfWeek,-1);}
return this;}
return this.moveToFirstDayOfMonth().addDays(-1).moveToDayOfWeek(dayOfWeek,+1).addWeeks(shift);};$P.moveToDayOfWeek=function(dayOfWeek,orient){var diff=(dayOfWeek-this.getDay()+7*(orient||+1))%7;return this.addDays((diff===0)?diff+=7*(orient||+1):diff);};$P.moveToMonth=function(month,orient){var diff=(month-this.getMonth()+12*(orient||+1))%12;return this.addMonths((diff===0)?diff+=12*(orient||+1):diff);};$P.getOrdinalNumber=function(){return Math.ceil((this.clone().clearTime()-new Date(this.getFullYear(),0,1))/86400000)+1;};$P.getTimezone=function(){return $D.getTimezoneAbbreviation(this.getUTCOffset());};$P.setTimezoneOffset=function(offset){var here=this.getTimezoneOffset(),there=Number(offset)*-6/10;return this.addMinutes(there-here);};$P.setTimezone=function(offset){return this.setTimezoneOffset($D.getTimezoneOffset(offset));};$P.hasDaylightSavingTime=function(){return(Date.today().set({month:0,day:1}).getTimezoneOffset()!==Date.today().set({month:6,day:1}).getTimezoneOffset());};$P.isDaylightSavingTime=function(){return(this.hasDaylightSavingTime()&&new Date().getTimezoneOffset()===Date.today().set({month:6,day:1}).getTimezoneOffset());};$P.getUTCOffset=function(){var n=this.getTimezoneOffset()*-10/6,r;if(n<0){r=(n-10000).toString();return r.charAt(0)+r.substr(2);}else{r=(n+10000).toString();return"+"+r.substr(1);}};$P.getElapsed=function(date){return(date||new Date())-this;};if(!$P.toISOString){$P.toISOString=function(){function f(n){return n<10?'0'+n:n;}
return'"'+this.getUTCFullYear()+'-'+
f(this.getUTCMonth()+1)+'-'+
f(this.getUTCDate())+'T'+
f(this.getUTCHours())+':'+
f(this.getUTCMinutes())+':'+
f(this.getUTCSeconds())+'Z"';};}
$P._toString=$P.toString;$P.toString=function(format){var x=this;if(format&&format.length==1){var c=$C.formatPatterns;x.t=x.toString;switch(format){case"d":return x.t(c.shortDate);case"D":return x.t(c.longDate);case"F":return x.t(c.fullDateTime);case"m":return x.t(c.monthDay);case"r":return x.t(c.rfc1123);case"s":return x.t(c.sortableDateTime);case"t":return x.t(c.shortTime);case"T":return x.t(c.longTime);case"u":return x.t(c.universalSortableDateTime);case"y":return x.t(c.yearMonth);}}
var ord=function(n){switch(n*1){case 1:case 21:case 31:return"st";case 2:case 22:return"nd";case 3:case 23:return"rd";default:return"th";}};return format?format.replace(/(\\)?(dd?d?d?|MM?M?M?|yy?y?y?|hh?|HH?|mm?|ss?|tt?|S)/g,function(m){if(m.charAt(0)==="\\"){return m.replace("\\","");}
x.h=x.getHours;switch(m){case"hh":return p(x.h()<13?(x.h()===0?12:x.h()):(x.h()-12));case"h":return x.h()<13?(x.h()===0?12:x.h()):(x.h()-12);case"HH":return p(x.h());case"H":return x.h();case"mm":return p(x.getMinutes());case"m":return x.getMinutes();case"ss":return p(x.getSeconds());case"s":return x.getSeconds();case"yyyy":return p(x.getFullYear(),4);case"yy":return p(x.getFullYear());case"dddd":return $C.dayNames[x.getDay()];case"ddd":return $C.abbreviatedDayNames[x.getDay()];case"dd":return p(x.getDate());case"d":return x.getDate();case"MMMM":return $C.monthNames[x.getMonth()];case"MMM":return $C.abbreviatedMonthNames[x.getMonth()];case"MM":return p((x.getMonth()+1));case"M":return x.getMonth()+1;case"t":return x.h()<12?$C.amDesignator.substring(0,1):$C.pmDesignator.substring(0,1);case"tt":return x.h()<12?$C.amDesignator:$C.pmDesignator;case"S":return ord(x.getDate());default:return m;}}):this._toString();};}());
(function(){var $D=Date,$P=$D.prototype,$C=$D.CultureInfo,$N=Number.prototype;$P._orient=+1;$P._nth=null;$P._is=false;$P._same=false;$P._isSecond=false;$N._dateElement="day";$P.next=function(){this._orient=+1;return this;};$D.next=function(){return $D.today().next();};$P.last=$P.prev=$P.previous=function(){this._orient=-1;return this;};$D.last=$D.prev=$D.previous=function(){return $D.today().last();};$P.is=function(){this._is=true;return this;};$P.same=function(){this._same=true;this._isSecond=false;return this;};$P.today=function(){return this.same().day();};$P.weekday=function(){if(this._is){this._is=false;return(!this.is().sat()&&!this.is().sun());}
return false;};$P.at=function(time){return(typeof time==="string")?$D.parse(this.toString("d")+" "+time):this.set(time);};$N.fromNow=$N.after=function(date){var c={};c[this._dateElement]=this;return((!date)?new Date():date.clone()).add(c);};$N.ago=$N.before=function(date){var c={};c[this._dateElement]=this*-1;return((!date)?new Date():date.clone()).add(c);};var dx=("sunday monday tuesday wednesday thursday friday saturday").split(/\s/),mx=("january february march april may june july august september october november december").split(/\s/),px=("Millisecond Second Minute Hour Day Week Month Year").split(/\s/),pxf=("Milliseconds Seconds Minutes Hours Date Week Month FullYear").split(/\s/),nth=("final first second third fourth fifth").split(/\s/),de;$P.toObject=function(){var o={};for(var i=0;i<px.length;i++){o[px[i].toLowerCase()]=this["get"+pxf[i]]();}
return o;};$D.fromObject=function(config){config.week=null;return Date.today().set(config);};var df=function(n){return function(){if(this._is){this._is=false;return this.getDay()==n;}
if(this._nth!==null){if(this._isSecond){this.addSeconds(this._orient*-1);}
this._isSecond=false;var ntemp=this._nth;this._nth=null;var temp=this.clone().moveToLastDayOfMonth();this.moveToNthOccurrence(n,ntemp);if(this>temp){throw new RangeError($D.getDayName(n)+" does not occur "+ntemp+" times in the month of "+$D.getMonthName(temp.getMonth())+" "+temp.getFullYear()+".");}
return this;}
return this.moveToDayOfWeek(n,this._orient);};};var sdf=function(n){return function(){var t=$D.today(),shift=n-t.getDay();if(n===0&&$C.firstDayOfWeek===1&&t.getDay()!==0){shift=shift+7;}
return t.addDays(shift);};};for(var i=0;i<dx.length;i++){$D[dx[i].toUpperCase()]=$D[dx[i].toUpperCase().substring(0,3)]=i;$D[dx[i]]=$D[dx[i].substring(0,3)]=sdf(i);$P[dx[i]]=$P[dx[i].substring(0,3)]=df(i);}
var mf=function(n){return function(){if(this._is){this._is=false;return this.getMonth()===n;}
return this.moveToMonth(n,this._orient);};};var smf=function(n){return function(){return $D.today().set({month:n,day:1});};};for(var j=0;j<mx.length;j++){$D[mx[j].toUpperCase()]=$D[mx[j].toUpperCase().substring(0,3)]=j;$D[mx[j]]=$D[mx[j].substring(0,3)]=smf(j);$P[mx[j]]=$P[mx[j].substring(0,3)]=mf(j);}
var ef=function(j){return function(){if(this._isSecond){this._isSecond=false;return this;}
if(this._same){this._same=this._is=false;var o1=this.toObject(),o2=(arguments[0]||new Date()).toObject(),v="",k=j.toLowerCase();for(var m=(px.length-1);m>-1;m--){v=px[m].toLowerCase();if(o1[v]!=o2[v]){return false;}
if(k==v){break;}}
return true;}
if(j.substring(j.length-1)!="s"){j+="s";}
return this["add"+j](this._orient);};};var nf=function(n){return function(){this._dateElement=n;return this;};};for(var k=0;k<px.length;k++){de=px[k].toLowerCase();$P[de]=$P[de+"s"]=ef(px[k]);$N[de]=$N[de+"s"]=nf(de);}
$P._ss=ef("Second");var nthfn=function(n){return function(dayOfWeek){if(this._same){return this._ss(arguments[0]);}
if(dayOfWeek||dayOfWeek===0){return this.moveToNthOccurrence(dayOfWeek,n);}
this._nth=n;if(n===2&&(dayOfWeek===undefined||dayOfWeek===null)){this._isSecond=true;return this.addSeconds(this._orient);}
return this;};};for(var l=0;l<nth.length;l++){$P[nth[l]]=(l===0)?nthfn(-1):nthfn(l);}}());
(function(){Date.Parsing={Exception:function(s){this.message="Parse error at '"+s.substring(0,10)+" ...'";}};var $P=Date.Parsing;var _=$P.Operators={rtoken:function(r){return function(s){var mx=s.match(r);if(mx){return([mx[0],s.substring(mx[0].length)]);}else{throw new $P.Exception(s);}};},token:function(s){return function(s){return _.rtoken(new RegExp("^\s*"+s+"\s*"))(s);};},stoken:function(s){return _.rtoken(new RegExp("^"+s));},until:function(p){return function(s){var qx=[],rx=null;while(s.length){try{rx=p.call(this,s);}catch(e){qx.push(rx[0]);s=rx[1];continue;}
break;}
return[qx,s];};},many:function(p){return function(s){var rx=[],r=null;while(s.length){try{r=p.call(this,s);}catch(e){return[rx,s];}
rx.push(r[0]);s=r[1];}
return[rx,s];};},optional:function(p){return function(s){var r=null;try{r=p.call(this,s);}catch(e){return[null,s];}
return[r[0],r[1]];};},not:function(p){return function(s){try{p.call(this,s);}catch(e){return[null,s];}
throw new $P.Exception(s);};},ignore:function(p){return p?function(s){var r=null;r=p.call(this,s);return[null,r[1]];}:null;},product:function(){var px=arguments[0],qx=Array.prototype.slice.call(arguments,1),rx=[];for(var i=0;i<px.length;i++){rx.push(_.each(px[i],qx));}
return rx;},cache:function(rule){var cache={},r=null;return function(s){try{r=cache[s]=(cache[s]||rule.call(this,s));}catch(e){r=cache[s]=e;}
if(r instanceof $P.Exception){throw r;}else{return r;}};},any:function(){var px=arguments;return function(s){var r=null;for(var i=0;i<px.length;i++){if(px[i]==null){continue;}
try{r=(px[i].call(this,s));}catch(e){r=null;}
if(r){return r;}}
throw new $P.Exception(s);};},each:function(){var px=arguments;return function(s){var rx=[],r=null;for(var i=0;i<px.length;i++){if(px[i]==null){continue;}
try{r=(px[i].call(this,s));}catch(e){throw new $P.Exception(s);}
rx.push(r[0]);s=r[1];}
return[rx,s];};},all:function(){var px=arguments,_=_;return _.each(_.optional(px));},sequence:function(px,d,c){d=d||_.rtoken(/^\s*/);c=c||null;if(px.length==1){return px[0];}
return function(s){var r=null,q=null;var rx=[];for(var i=0;i<px.length;i++){try{r=px[i].call(this,s);}catch(e){break;}
rx.push(r[0]);try{q=d.call(this,r[1]);}catch(ex){q=null;break;}
s=q[1];}
if(!r){throw new $P.Exception(s);}
if(q){throw new $P.Exception(q[1]);}
if(c){try{r=c.call(this,r[1]);}catch(ey){throw new $P.Exception(r[1]);}}
return[rx,(r?r[1]:s)];};},between:function(d1,p,d2){d2=d2||d1;var _fn=_.each(_.ignore(d1),p,_.ignore(d2));return function(s){var rx=_fn.call(this,s);return[[rx[0][0],r[0][2]],rx[1]];};},list:function(p,d,c){d=d||_.rtoken(/^\s*/);c=c||null;return(p instanceof Array?_.each(_.product(p.slice(0,-1),_.ignore(d)),p.slice(-1),_.ignore(c)):_.each(_.many(_.each(p,_.ignore(d))),px,_.ignore(c)));},set:function(px,d,c){d=d||_.rtoken(/^\s*/);c=c||null;return function(s){var r=null,p=null,q=null,rx=null,best=[[],s],last=false;for(var i=0;i<px.length;i++){q=null;p=null;r=null;last=(px.length==1);try{r=px[i].call(this,s);}catch(e){continue;}
rx=[[r[0]],r[1]];if(r[1].length>0&&!last){try{q=d.call(this,r[1]);}catch(ex){last=true;}}else{last=true;}
if(!last&&q[1].length===0){last=true;}
if(!last){var qx=[];for(var j=0;j<px.length;j++){if(i!=j){qx.push(px[j]);}}
p=_.set(qx,d).call(this,q[1]);if(p[0].length>0){rx[0]=rx[0].concat(p[0]);rx[1]=p[1];}}
if(rx[1].length<best[1].length){best=rx;}
if(best[1].length===0){break;}}
if(best[0].length===0){return best;}
if(c){try{q=c.call(this,best[1]);}catch(ey){throw new $P.Exception(best[1]);}
best[1]=q[1];}
return best;};},forward:function(gr,fname){return function(s){return gr[fname].call(this,s);};},replace:function(rule,repl){return function(s){var r=rule.call(this,s);return[repl,r[1]];};},process:function(rule,fn){return function(s){var r=rule.call(this,s);return[fn.call(this,r[0]),r[1]];};},min:function(min,rule){return function(s){var rx=rule.call(this,s);if(rx[0].length<min){throw new $P.Exception(s);}
return rx;};}};var _generator=function(op){return function(){var args=null,rx=[];if(arguments.length>1){args=Array.prototype.slice.call(arguments);}else if(arguments[0]instanceof Array){args=arguments[0];}
if(args){for(var i=0,px=args.shift();i<px.length;i++){args.unshift(px[i]);rx.push(op.apply(null,args));args.shift();return rx;}}else{return op.apply(null,arguments);}};};var gx="optional not ignore cache".split(/\s/);for(var i=0;i<gx.length;i++){_[gx[i]]=_generator(_[gx[i]]);}
var _vector=function(op){return function(){if(arguments[0]instanceof Array){return op.apply(null,arguments[0]);}else{return op.apply(null,arguments);}};};var vx="each any all".split(/\s/);for(var j=0;j<vx.length;j++){_[vx[j]]=_vector(_[vx[j]]);}}());(function(){var $D=Date,$P=$D.prototype,$C=$D.CultureInfo;var flattenAndCompact=function(ax){var rx=[];for(var i=0;i<ax.length;i++){if(ax[i]instanceof Array){rx=rx.concat(flattenAndCompact(ax[i]));}else{if(ax[i]){rx.push(ax[i]);}}}
return rx;};$D.Grammar={};$D.Translator={hour:function(s){return function(){this.hour=Number(s);};},minute:function(s){return function(){this.minute=Number(s);};},second:function(s){return function(){this.second=Number(s);};},meridian:function(s){return function(){this.meridian=s.slice(0,1).toLowerCase();};},timezone:function(s){return function(){var n=s.replace(/[^\d\+\-]/g,"");if(n.length){this.timezoneOffset=Number(n);}else{this.timezone=s.toLowerCase();}};},day:function(x){var s=x[0];return function(){this.day=Number(s.match(/\d+/)[0]);};},month:function(s){return function(){this.month=(s.length==3)?"jan feb mar apr may jun jul aug sep oct nov dec".indexOf(s)/4:Number(s)-1;};},year:function(s){return function(){var n=Number(s);this.year=((s.length>2)?n:(n+(((n+2000)<$C.twoDigitYearMax)?2000:1900)));};},rday:function(s){return function(){switch(s){case"yesterday":this.days=-1;break;case"tomorrow":this.days=1;break;case"today":this.days=0;break;case"now":this.days=0;this.now=true;break;}};},finishExact:function(x){x=(x instanceof Array)?x:[x];for(var i=0;i<x.length;i++){if(x[i]){x[i].call(this);}}
var now=new Date();if((this.hour||this.minute)&&(!this.month&&!this.year&&!this.day)){this.day=now.getDate();}
if(!this.year){this.year=now.getFullYear();}
if(!this.month&&this.month!==0){this.month=now.getMonth();}
if(!this.day){this.day=1;}
if(!this.hour){this.hour=0;}
if(!this.minute){this.minute=0;}
if(!this.second){this.second=0;}
if(this.meridian&&this.hour){if(this.meridian=="p"&&this.hour<12){this.hour=this.hour+12;}else if(this.meridian=="a"&&this.hour==12){this.hour=0;}}
if(this.day>$D.getDaysInMonth(this.year,this.month)){throw new RangeError(this.day+" is not a valid value for days.");}
var r=new Date(this.year,this.month,this.day,this.hour,this.minute,this.second);if(this.timezone){r.set({timezone:this.timezone});}else if(this.timezoneOffset){r.set({timezoneOffset:this.timezoneOffset});}
return r;},finish:function(x){x=(x instanceof Array)?flattenAndCompact(x):[x];if(x.length===0){return null;}
for(var i=0;i<x.length;i++){if(typeof x[i]=="function"){x[i].call(this);}}
var today=$D.today();if(this.now&&!this.unit&&!this.operator){return new Date();}else if(this.now){today=new Date();}
var expression=!!(this.days&&this.days!==null||this.orient||this.operator);var gap,mod,orient;orient=((this.orient=="past"||this.operator=="subtract")?-1:1);if(!this.now&&"hour minute second".indexOf(this.unit)!=-1){today.setTimeToNow();}
if(this.month||this.month===0){if("year day hour minute second".indexOf(this.unit)!=-1){this.value=this.month+1;this.month=null;expression=true;}}
if(!expression&&this.weekday&&!this.day&&!this.days){var temp=Date[this.weekday]();this.day=temp.getDate();if(!this.month){this.month=temp.getMonth();}
this.year=temp.getFullYear();}
if(expression&&this.weekday&&this.unit!="month"){this.unit="day";gap=($D.getDayNumberFromName(this.weekday)-today.getDay());mod=7;this.days=gap?((gap+(orient*mod))%mod):(orient*mod);}
if(this.month&&this.unit=="day"&&this.operator){this.value=(this.month+1);this.month=null;}
if(this.value!=null&&this.month!=null&&this.year!=null){this.day=this.value*1;}
if(this.month&&!this.day&&this.value){today.set({day:this.value*1});if(!expression){this.day=this.value*1;}}
if(!this.month&&this.value&&this.unit=="month"&&!this.now){this.month=this.value;expression=true;}
if(expression&&(this.month||this.month===0)&&this.unit!="year"){this.unit="month";gap=(this.month-today.getMonth());mod=12;this.months=gap?((gap+(orient*mod))%mod):(orient*mod);this.month=null;}
if(!this.unit){this.unit="day";}
if(!this.value&&this.operator&&this.operator!==null&&this[this.unit+"s"]&&this[this.unit+"s"]!==null){this[this.unit+"s"]=this[this.unit+"s"]+((this.operator=="add")?1:-1)+(this.value||0)*orient;}else if(this[this.unit+"s"]==null||this.operator!=null){if(!this.value){this.value=1;}
this[this.unit+"s"]=this.value*orient;}
if(this.meridian&&this.hour){if(this.meridian=="p"&&this.hour<12){this.hour=this.hour+12;}else if(this.meridian=="a"&&this.hour==12){this.hour=0;}}
if(this.weekday&&!this.day&&!this.days){var temp=Date[this.weekday]();this.day=temp.getDate();if(temp.getMonth()!==today.getMonth()){this.month=temp.getMonth();}}
if((this.month||this.month===0)&&!this.day){this.day=1;}
if(!this.orient&&!this.operator&&this.unit=="week"&&this.value&&!this.day&&!this.month){return Date.today().setWeek(this.value);}
if(expression&&this.timezone&&this.day&&this.days){this.day=this.days;}
return(expression)?today.add(this):today.set(this);}};var _=$D.Parsing.Operators,g=$D.Grammar,t=$D.Translator,_fn;g.datePartDelimiter=_.rtoken(/^([\s\-\.\,\/\x27]+)/);g.timePartDelimiter=_.stoken(":");g.whiteSpace=_.rtoken(/^\s*/);g.generalDelimiter=_.rtoken(/^(([\s\,]|at|@|on)+)/);var _C={};g.ctoken=function(keys){var fn=_C[keys];if(!fn){var c=$C.regexPatterns;var kx=keys.split(/\s+/),px=[];for(var i=0;i<kx.length;i++){px.push(_.replace(_.rtoken(c[kx[i]]),kx[i]));}
fn=_C[keys]=_.any.apply(null,px);}
return fn;};g.ctoken2=function(key){return _.rtoken($C.regexPatterns[key]);};g.h=_.cache(_.process(_.rtoken(/^(0[0-9]|1[0-2]|[1-9])/),t.hour));g.hh=_.cache(_.process(_.rtoken(/^(0[0-9]|1[0-2])/),t.hour));g.H=_.cache(_.process(_.rtoken(/^([0-1][0-9]|2[0-3]|[0-9])/),t.hour));g.HH=_.cache(_.process(_.rtoken(/^([0-1][0-9]|2[0-3])/),t.hour));g.m=_.cache(_.process(_.rtoken(/^([0-5][0-9]|[0-9])/),t.minute));g.mm=_.cache(_.process(_.rtoken(/^[0-5][0-9]/),t.minute));g.s=_.cache(_.process(_.rtoken(/^([0-5][0-9]|[0-9])/),t.second));g.ss=_.cache(_.process(_.rtoken(/^[0-5][0-9]/),t.second));g.hms=_.cache(_.sequence([g.H,g.m,g.s],g.timePartDelimiter));g.t=_.cache(_.process(g.ctoken2("shortMeridian"),t.meridian));g.tt=_.cache(_.process(g.ctoken2("longMeridian"),t.meridian));g.z=_.cache(_.process(_.rtoken(/^((\+|\-)\s*\d\d\d\d)|((\+|\-)\d\d\:?\d\d)/),t.timezone));g.zz=_.cache(_.process(_.rtoken(/^((\+|\-)\s*\d\d\d\d)|((\+|\-)\d\d\:?\d\d)/),t.timezone));g.zzz=_.cache(_.process(g.ctoken2("timezone"),t.timezone));g.timeSuffix=_.each(_.ignore(g.whiteSpace),_.set([g.tt,g.zzz]));g.time=_.each(_.optional(_.ignore(_.stoken("T"))),g.hms,g.timeSuffix);g.d=_.cache(_.process(_.each(_.rtoken(/^([0-2]\d|3[0-1]|\d)/),_.optional(g.ctoken2("ordinalSuffix"))),t.day));g.dd=_.cache(_.process(_.each(_.rtoken(/^([0-2]\d|3[0-1])/),_.optional(g.ctoken2("ordinalSuffix"))),t.day));g.ddd=g.dddd=_.cache(_.process(g.ctoken("sun mon tue wed thu fri sat"),function(s){return function(){this.weekday=s;};}));g.M=_.cache(_.process(_.rtoken(/^(1[0-2]|0\d|\d)/),t.month));g.MM=_.cache(_.process(_.rtoken(/^(1[0-2]|0\d)/),t.month));g.MMM=g.MMMM=_.cache(_.process(g.ctoken("jan feb mar apr may jun jul aug sep oct nov dec"),t.month));g.y=_.cache(_.process(_.rtoken(/^(\d\d?)/),t.year));g.yy=_.cache(_.process(_.rtoken(/^(\d\d)/),t.year));g.yyy=_.cache(_.process(_.rtoken(/^(\d\d?\d?\d?)/),t.year));g.yyyy=_.cache(_.process(_.rtoken(/^(\d\d\d\d)/),t.year));_fn=function(){return _.each(_.any.apply(null,arguments),_.not(g.ctoken2("timeContext")));};g.day=_fn(g.d,g.dd);g.month=_fn(g.M,g.MMM);g.year=_fn(g.yyyy,g.yy);g.orientation=_.process(g.ctoken("past future"),function(s){return function(){this.orient=s;};});g.operator=_.process(g.ctoken("add subtract"),function(s){return function(){this.operator=s;};});g.rday=_.process(g.ctoken("yesterday tomorrow today now"),t.rday);g.unit=_.process(g.ctoken("second minute hour day week month year"),function(s){return function(){this.unit=s;};});g.value=_.process(_.rtoken(/^\d\d?(st|nd|rd|th)?/),function(s){return function(){this.value=s.replace(/\D/g,"");};});g.expression=_.set([g.rday,g.operator,g.value,g.unit,g.orientation,g.ddd,g.MMM]);_fn=function(){return _.set(arguments,g.datePartDelimiter);};g.mdy=_fn(g.ddd,g.month,g.day,g.year);g.ymd=_fn(g.ddd,g.year,g.month,g.day);g.dmy=_fn(g.ddd,g.day,g.month,g.year);g.date=function(s){return((g[$C.dateElementOrder]||g.mdy).call(this,s));};g.format=_.process(_.many(_.any(_.process(_.rtoken(/^(dd?d?d?|MM?M?M?|yy?y?y?|hh?|HH?|mm?|ss?|tt?|zz?z?)/),function(fmt){if(g[fmt]){return g[fmt];}else{throw $D.Parsing.Exception(fmt);}}),_.process(_.rtoken(/^[^dMyhHmstz]+/),function(s){return _.ignore(_.stoken(s));}))),function(rules){return _.process(_.each.apply(null,rules),t.finishExact);});var _F={};var _get=function(f){return _F[f]=(_F[f]||g.format(f)[0]);};g.formats=function(fx){if(fx instanceof Array){var rx=[];for(var i=0;i<fx.length;i++){rx.push(_get(fx[i]));}
return _.any.apply(null,rx);}else{return _get(fx);}};g._formats=g.formats(["\"yyyy-MM-ddTHH:mm:ssZ\"","yyyy-MM-ddTHH:mm:ssZ","yyyy-MM-ddTHH:mm:ssz","yyyy-MM-ddTHH:mm:ss","yyyy-MM-ddTHH:mmZ","yyyy-MM-ddTHH:mmz","yyyy-MM-ddTHH:mm","ddd, MMM dd, yyyy H:mm:ss tt","ddd MMM d yyyy HH:mm:ss zzz","MMddyyyy","ddMMyyyy","Mddyyyy","ddMyyyy","Mdyyyy","dMyyyy","yyyy","Mdyy","dMyy","d"]);g._start=_.process(_.set([g.date,g.time,g.expression],g.generalDelimiter,g.whiteSpace),t.finish);g.start=function(s){try{var r=g._formats.call({},s);if(r[1].length===0){return r;}}catch(e){}
return g._start.call({},s);};$D._parse=$D.parse;$D.parse=function(s){var r=null;if(!s){return null;}
if(s instanceof Date){return s;}
try{r=$D.Grammar.start.call({},s.replace(/^\s*(\S*(\s+\S+)*)\s*$/,"$1"));}catch(e){return null;}
return((r[1].length===0)?r[0]:null);};$D.getParseFunction=function(fx){var fn=$D.Grammar.formats(fx);return function(s){var r=null;try{r=fn.call({},s);}catch(e){return null;}
return((r[1].length===0)?r[0]:null);};};$D.parseExact=function(s,fx){return $D.getParseFunction(fx)(s);};}());



//--------------------------------------------------------------------------------
// File: ./js/streamingconfig.js
//--------------------------------------------------------------------------------

export var jdsdomain = "/";
//export var jdsdomain = "http://t12a.trkd-hs.com/";
//var jdsdomain = "//www.example.com/";
//var jdsdomain = "http://www.example.com/";

export var jdspath = "jds";

export var boot = {

//################################################################################
//# LFA DEVELOPMENT Configuration
//################################################################################
//    subUrl:      "../emustream/request.jsp",
//    streamUrl:   "../emustream/stream.jsp",
//    PROTO_CHECK_TIMEOUT: 400000,
//    FORCE_POLLING:       false,

//################################################################################
//# LFA STAGING / PRODUCTION Configuration
//################################################################################
    subUrl:      [jdsdomain, jdspath, "/req", "?token=", urlParams, "_", q_id].join(""),
    streamUrl:   [jdsdomain, jdspath, "/res"].join(""),
    pollUrl:     [jdsdomain, jdspath, "/pol", "?token=", urlParams, "_", q_id].join(""),
    PROTO_CHECK_TIMEOUT: 5000,
    FORCE_POLLING:       false,

//    E.g. Get token from "https://www.example.com/desktop24/js/streamingconfig.js.jsp"
    token:       "monex02",

    conflate:    3000,

    jd:          "dHBbPH8FbH8bBCD8SJRbnnupnntxnntonntvbjlk98m9gB8ADDdDkAC9eijfkeieCiffihkDA9Ckd9BhA99gldC8C98mejCfgg9AA",

    // The default value, to be cc-specified...
    TZ_LOCAL_OFFSET: { hours: 9, minutes: 0 } // default: GMT+9
};

//
//
//
//

//
//
//

// JPN
boot.TZ_LOCAL_OFFSET = { hours: 9, minutes: 0 }; // GMT+9

//################################################################################
export var _ENABLE_PRICE_ALERT = false;
export var PRICE_ALERT_WHITELIST = [];


//--------------------------------------------------------------------------------
// File: ./js/streaming.js
//--------------------------------------------------------------------------------

//################################################################################
// The Desktop Object for Core Streaming Communication

// The streaming data frame URL

export var _STREAM_URL = [boot.streamUrl, "?token=", urlParams,"_",q_id,"&conflate=",boot.conflate].join(""); // direct access to the jds data interface
// console.log("_STREAM_URL",_STREAM_URL)
//var _STREAM_URL = "../streaming/dataframe.jsp"; // wrapped the call to the jds data interface by the dataframe.jsp (using XHR to load data)

//################################################################################

// Watch info class

export function WatchInfo() {
    this.refCount=1;
}

// Ric request/cancellation command info class

export function CommandInfo() {
    this.text=null;
    this.exec=false;
    this.retryCount=0;
}

// Stream info class

export function StreamInfo(time) {
    this.protoCheck=true;    // Check if the hidden streaming frame mechanism is blocked by virus scanner
    this.emulateMode=false;  // Emulate streaming by repeated polling
    this.abortPoll=false;
    this.brokenPoll=false;   // Last polling has an error
    this.lastTick=time;
    this.lastMsg=time;
    this.retryCount=0;
    this.lastRefresh=time;
    this.serverName=null;
}

export function StringBuffer() {
    this.buffer=[];

    this.clear=function() {
        this.buffer.length=0;
        return this;
    };

    this.append=function(s) {
        this.buffer.push(s);
        return this;
    };

    this.toString=function() {
        return this.buffer.join("");
    };

    this.empty=function() {
        return (this.buffer.length==0);
    };
}

// Desktop constants & functions

export var desktop = window.desktop = {
    // For accessing the session token
    SESSION_TOKEN: "fubon_"+q_id,
    register: function(pageobj) {
        console.log('hello')
        pages[pageobj.id] = pageobj;
    },

    unregister: function(pageobj) {
        if (pages[pageobj.id]) {
            delete pages[pageobj.id];
            Streaming.unsubscribe(pageobj.$pageobj, true);
            //pageobj.$pageobj.find(":data(issub)").data("issub", "false");
            return true;
        }
        else
            return false;
    },

    subscribe: function(service, ric, fid) {
        if (service.indexOf(",")== -1 && ric.indexOf(",")== -1) {
            var type=(fid ? $.type(fid) : null);

            // Special handling for IE, when being called across browsers, array will be turned into "object" (in terms of type)...
            // ... the logic will parse the "object" and rebuild into a proper array
            if (type == "object") {
                var fidstr = ""+fid;
                if (fidstr.length > 0) {
                    fid = fidstr.split(",");
                    type = "array";
                }
            }

            if (type==null || type=="number" || type=="string" || type=="array" && fid.length > 0) {
                var watches=services[service];
                if (!watches)
                    watches=services[service]={};

                var watch=watches[ric];
                if (watch)
                    watch.refCount++;
                else
                    watch=watches[ric]=new WatchInfo();

                if (type=="number" || type=="string") {
                    watch[fid]=true;
                }
                else if (type=="array") {
                    for (var i=0;i<fid.length;i++)
                        watch[fid[i]]=true;
                }

                var key=[service, ",", ric].join("");
                if (stopSet[key])
                    delete stopSet[key];
                useSet[key]=true;

                return true;
            }
        }
        return false;
    },

    unsubscribe: function(service, ric) {
        var watches=services[service];
        if (watches) {
            var watch=watches[ric];
            if (watch) {
                watch.refCount--;
                if (watch.refCount==0) {
                    var key=[service, ",", ric].join("");
                    if (useSet[key])
                        delete useSet[key];
                    stopSet[key]=true;

                    delete watches[ric];
                }
                return true;
            }
        }
        return false;
    },

    stream: function(data) {

//////var _st = $.now();

        // If data in JSON string format, parse it, otherwise this is already an js object of the data
        if (typeof data == "string") data = $.parseJSON(data);

//////CONSOLELOGGER.info(JSON.stringify(data));

        var pagescnt = 0;
        var basecnt = 0;
        
        // For all other registered pages
        for (var id in pages) {
            try {
//                var callback=windows[id].callback;
                if (pages[id].stream)
                    try {
                        // IE is unable to catch exception thrown from iframe
                        pages[id].stream(data);
                        pagescnt++;
                        if (id.startsWith("_")) {
                            basecnt++;
                        }
                    }
                    catch (e) {
                        //////CONSOLELOGGER.debug("desktop.js:desktop.stream() [desktop.error.internal-" + id + "]... ignore this round of data");
                    }
            }
            catch (e) {
                //////CONSOLELOGGER.debug("desktop.js:desktop.stream() [desktop.error.internal-" + id + "]... remove this #id reference from pages");
                delete pages[id];
            }
        }
        
        if (basecnt==2 && pagescnt==2) {
           Streaming.stream("null", data);
        }

//////var _et = $.now();
//////CONSOLELOGGER.info("Desktop.stream(): " + (_et - _st));

    },
    
    getConnStatus: function() {
        return connstatus;
    },
    
    connStatusChange: function(status) {
        connstatus = status;
        for (var id in pages) {
            try {
                if (pages[id].connStatusChange)
                    try {
                        // IE is unable to catch exception thrown from iframe
                        pages[id].connStatusChange(status);
                    }
                    catch (e) {
                        //////CONSOLELOGGER.debug("desktop.js:desktop.stream() [desktop.error.internal-" + id + "]... ignore this round of data");
                    }
            }
            catch (e) {
                //////CONSOLELOGGER.debug("desktop.js:desktop.stream() [desktop.error.internal-" + id + "]... remove this #id reference from pages");
                delete pages[id];
            }
        }
    }
};

// Root window constants & callback

export var root = AbstractPageObj.extend("_root", {
    LOST_COOKIE_CHECK:   5,

    SYS_SERVICE:         "SYS",
    AJAX_TIMEOUT:        5000,
    POLL_TIMEOUT:        40000,
    REFRESH_PERIOD:      300000,

    PROTO_CHECK_TIMEOUT: boot.PROTO_CHECK_TIMEOUT,

    NO_MSG_TIMEOUT:      20000, // JH20140410> Changed from 12s to 20s...
    MAX_RETRY:           75,
    MAX_RETRY_REQ:       3,

    // Implementation of the AbstractPageObj
    stream: function(data) {
        var props=data[this.SYS_SERVICE];
        if (props) {
            // Detect server change
            var serverName=props[0];
            if (serverName) {
                if (si.serverName==null)
                    si.serverName=serverName;
                else if (si.serverName != serverName) {
                    recovery();
                    si.serverName=serverName;
                    //////CONSOLELOGGER.debug("desktop.js:root.stream() [desktop.error.connection.serverChange]");
                }
            }

            // Streaming frame refresh triggered by server
            if (props[1] && !si.emulateMode) {
                if ($STREAMING_FRAME) $STREAMING_FRAME[0].contentWindow.location.replace(_STREAM_URL);

                var now=new Date().getTime();
                si.lastRefresh=now;
            }

//            // Output system message
//            if (props[2]) {
//                //////CONSOLELOGGER.debug("desktop.js:root.stream() [" + props[2] + "]");
//            }
        }

        if (si.retryCount > 0) {
            recovery();
            si.retryCount=0;
            //////CONSOLELOGGER.debug("desktop.js:root.stream() [desktop.info.connection.resume]");
        }
        
        // Change connstatus to 1 if current is 0
        if (desktop.getConnStatus() == 0) {
            desktop.connStatusChange(1);
        }

        if (!boot.FORCE_POLLING) si.protoCheck=false;

        si.lastMsg=si.lastTick;
    }
});

// Polling options & callback
export var jqXHR_POLL = null;

export var pollOptions = {
    type:        "POST",
    url:         boot.pollUrl,
    contentType: "application/x-www-form-urlencoded; charset=UTF-8",
    dataType:    "json",
    timeout:     root.POLL_TIMEOUT,
    data: {
        ts: $.now(),
        token: "fubon_"+q_id
    },

    success: function(data, status, xhr) {
        if (data != null) {
            
            var pagescnt = 0;
            var basecnt = 0;
            
            for (var id in pages) {
                try {
//                    var callback=windows[id].callback;
                    if (pages[id].stream)
                        try {
                            // IE is unable to catch exception thrown from iframe
                            pages[id].stream(data);
                            pagescnt++;
                            if (id.startsWith("_")) {
                                basecnt++;
                            }
                        }
                        catch (e) {
                            //////CONSOLELOGGER.debug("desktop.js:pollOptions.success() [desktop.error.internal-" + id + "]");
                        }
                }
                catch (e) {
                    delete windows[id];
                }
            }
        
            if (basecnt==2 && pagescnt==2) {
               Streaming.stream("null", data);
            }
        }
        
        if (!si.abortPoll) {
            $STREAMING_FRAME.delaycall("polloptions", function(){
                pollOptions.data.ts = $.now();
                pollOptions.data.token="fubon_"+q_id
                jqXHR_POLL = $.ajax(pollOptions);
            }, boot.conflate);
        }
        else {
            jqXHR_POLL = null;
        }
    },

    error: function(xhr, status, error) {
        jqXHR_POLL = null;

        //////CONSOLELOGGER.debug("desktop.js:pollOptions.success() [desktop.error.connection.poll]");
        si.brokenPoll = true;  // Restart polling on next timer tick
    }
};

// Other global variables

export var windows={};      // id -> WinInfo
export var pages={};        // id -> PageObj
export var services={};     // service name -> ric -> WatchInfo
export var useSet={};
export var stopSet={};
export var useCmd=new CommandInfo();
export var stopCmd=new CommandInfo();
export var si; //=new StreamInfo(new Date().getTime());
//export var lostCookieTimer=0;
//export var quit=false;
export var sb=new StringBuffer();

export var cmdTickStarted = false;

export var connstatus = 0;     // 0 - Disconnect, 1 - Connect

// Private functions

export function recovery() {
    // Re-request all rics after server change
    for (var service in services) {
        var watches=services[service];
        for (var ric in watches) {
//            var watch=watches[ric];
            var key=[service, ",", ric].join("");
            useSet[key]=true;
        }
    }

    stopSet={};
}

// Timer function

export function tick() {
    // In case if this may have been stopped?
    if (!cmdTickStarted) return;

    // In case this is logout by another instance

    //    lostCookieTimer++;
    //    if (lostCookieTimer==root.LOST_COOKIE_CHECK) {
    //        if (window.document.cookie.indexOf("jd=")== -1) {
    //            window.location.reload();  // Go to the login page
    //            return;
    //        }
    //
    //        lostCookieTimer=0;
    //    }

    if (!si.protoCheck && useCmd.text==null && stopCmd.text==null) {
        // Process ric request
        sb.clear();
        for (var key in useSet) {
            if (!sb.empty())
                sb.append(";");
            sb.append(key);

            var i=key.indexOf(",");
            var watch=services[key.substr(0,i)][key.substr(i+1)];

            for (var fid in watch)
                if (fid != "refCount")
                    sb.append(",").append(fid);
        }

        if (!sb.empty()) {
            useCmd.text=sb.toString();  // Format: <Service 1>,<Ric 1>,<Fid 1>,<Fid 2>,...;<Service 2>,<Ric 2>,<Fid 1>,<Fid 2>,...;...
            useCmd.exec=true;
            useCmd.retryCount=0;

            useSet={};
        }

        // Process ric cancellation
        sb.clear();
        for (var key in stopSet) {
            if (!sb.empty())
                sb.append(";");
            sb.append(key);
        }

        if (!sb.empty()) {
            stopCmd.text=sb.toString();  // Format: <Service 1>,<Ric 1>;<Service 2>,<Ric 2>;...
            stopCmd.exec=true;
            stopCmd.retryCount=0;

            stopSet={};
        }
    }

    // Send ric request
    if (useCmd.exec) {
        $.ajax({
            type:    "POST",
            url:     boot.subUrl,
            timeout: root.AJAX_TIMEOUT,
            data: {
                ts: $.now(),
                action:0,
                ric:useCmd.text,
                token:"fubon_"+q_id
            },

            success: function(data, status, xhr) {
//                if (useCmd.retryCount > 0)
//                    //////CONSOLELOGGER.debug("desktop.js:success() [desktop.info.connection.resume]");
                useCmd.text=null;
                window.checkStreamingUpdate(false)

            },

            error: function(xhr, status, error) {
                //////CONSOLELOGGER.debug("desktop.js:error() [desktop.error.connection.subscribe-" + useCmd.text + "]");
                window.checkStreamingUpdate(false)
                useCmd.retryCount++;
                if (useCmd.retryCount < root.MAX_RETRY_REQ)
                    useCmd.exec=true;
                else
                    useCmd.text=null;
            }
        });

        useCmd.exec=false;

    }
    // Send ric cancellation
    if (stopCmd.exec) {
        $.ajax({
            type:    "POST",
            url:     boot.subUrl,
            timeout: root.AJAX_TIMEOUT,
            data: {
                ts: $.now(),
                action:1,
                ric:stopCmd.text,
                token:"fubon_"+q_id
            },

            success: function(data, status, xhr) {
//                if (stopCmd.retryCount > 0)
//                    //////CONSOLELOGGER.debug("desktop.js:success() [desktop.info.connection.resume]")
                stopCmd.text=null;
                window.checkStreamingUpdate(false)

            },

            error: function(xhr, status, error) {
                //////CONSOLELOGGER.debug("desktop.js:error() [desktop.error.connection.unsubscribe-" + stopCmd.text + "]");
                window.checkStreamingUpdate(false)
                stopCmd.retryCount++;
                if (stopCmd.retryCount < root.MAX_RETRY_REQ)
                    stopCmd.exec=true;
                else
                    stopCmd.text=null;
            }
        });

        stopCmd.exec=false;
    }

    // Check if logout is done
//    if (quit) {
//        triggerLogout("s1");
//        return;
//    }

    // Handle streaming protocol
    var now=new Date().getTime();

    if (si.protoCheck) {
        if (boot.FORCE_POLLING || (now - si.lastMsg > root.PROTO_CHECK_TIMEOUT)) {
            // Stop the hidden streaming frame
            if ($STREAMING_FRAME) $STREAMING_FRAME.attr("src", "about:blank");

            si.protoCheck=false;
            si.emulateMode=true;
            si.brokenPoll=true;
            si.lastMsg=now;

            //////CONSOLELOGGER.debug("desktop.js [desktop.info.connection.emulateMode]");
        }
    }
    else if (si.retryCount < root.MAX_RETRY) {
        if (now - si.lastMsg > root.NO_MSG_TIMEOUT) { // No message was received for the past 12 sec
            si.retryCount++;
            desktop.connStatusChange(0);
            if (si.retryCount==root.MAX_RETRY) {
                if (si.emulateMode)
                    si.abortPoll=true;
                else
                    // Stop the hidden streaming frame
                    if ($STREAMING_FRAME) $STREAMING_FRAME.attr("src", "about:blank");

                //////CONSOLELOGGER.debug("desktop.js [desktop.error.connection.lost]");
            }
            else {
                if (!si.emulateMode) {
                    if ($STREAMING_FRAME) $STREAMING_FRAME[0].contentWindow.location.replace(_STREAM_URL);
                    si.lastRefresh=now;
                }

                si.lastMsg=now;
                //////CONSOLELOGGER.debug("desktop.js [desktop.error.connection.noMsgTimeOut]");
            }
        }
        else if (!si.emulateMode && (now - si.lastRefresh) > root.REFRESH_PERIOD) {
            // For clean-up, the streaming frame must be refreshed at least once every 300 sec
            if ($STREAMING_FRAME) $STREAMING_FRAME[0].contentWindow.location.replace(_STREAM_URL);
            si.lastRefresh=now;
        }
    }

    if (si.brokenPoll && !si.abortPoll) {
        // Let's resume, if really not yet any running...
        if (!jqXHR_POLL) {
            pollOptions.data.ts = $.now();
            pollOptions.data.token="fubon_"+q_id
            jqXHR_POLL = $.ajax(pollOptions);
        }
    }

    si.lastTick=now;

    // Continue?
    if (cmdTickStarted) setTimeout(tick, 1000);
}

//################################################################################
//################################################################################
// The Streaming Object for Streaming Data Processing

export var Streaming = function() {
    var NEWS_SERVICE="N2K";
    var IDN_SERVICE="IDN_RDF";
//    var IDN_SERVICE="ELEKTRON_DD";
    var hl=0;
//    var upstyles=[];
//    var downstyles=[];
//    var defaultstyles=[];
//    var stop=false;
    var tickStarted=false;
    var desktop=window.desktop;
    var winId=window.name;
    var queryStr=null;
    var zeroReplacement='-';
    var customFunc=[];
    var fidValStore=[];
    var posRefStore=[];
    var tickStep=2; // all modern browsers, better seting maybe: 5, lowest to 2
    var tickSleep=700; // all modern browsers, better seting maybe: 200, lowest to 700
    var tickStep_msie_old=1; // for msie7 or below, may include msie8
    var tickSleep_msie_old=2000; // for msie7 or below, may include msie8
//    var flashStore=[];
    var timefmt = "HH:mm";
    var datefmt = FORMATPATTERN_TRADE_DATE_MD; //"MM/dd"

    // For ranking streaming
    var subrankrics=[];
    var subrankobjs=[];
    var subranktables=[];
    var initrankrics=[];
    var subfid=[];
    var stockinfo=[];
    var rankShowCounter=[];
    var rankContextPath='';
    var isrankclean=[];

    // For T&S streaming
    var tsfid=[];
    var tsFidValStore=[];
    var tsPrevFidValStore=[];

    // For Price Alert check
//    var pafid=["6","11","22","56","90","91","3265","3266"];

    function init() {
        //hl=0;
//        upstyles=[];
//        downstyles=[];
//        defaultstyles=[];
//        stop=false;
        //tickStarted=false;
        queryStr=null;
        customFunc=[];
        fidValStore=[];
        subrankrics=[];
        subrankobjs=[];
        initrankrics=[];
        subfid=[];
        tsfid=[];
        tsFidValStore=[];
        tsPrevFidValStore=[];
//        tsCounter=-1;
        posRefStore=[];
//        flashStore=[];
        rankShowCounter=[];

        // With performance consideration, older IE will flash less frequently
//        if (isMSIE_OLD() || isMSIE8()) {
        if (isMSIE_OLD()) {
            tickStep = tickStep_msie_old;
            tickSleep = tickSleep_msie_old;
        }

        // Quote Streaming
        //    quoteinit();

        // Ranking Streaming
        //    rankinit();

        // Time & Sales Streaming
        //    tsinit();

        // News Streaming
        //    newsinit();

        }
    function quoteinit(ricList,fidList) {
        // console.log(JSON.stringify(ricList))
        ricList.map((val)=>{
            // console.log(IDN_SERVICE, val, JSON.parse(JSON.stringify(fidList)))
            desktop.subscribe(IDN_SERVICE, val, JSON.parse(JSON.stringify(fidList)));
        })
    }
    function rankinit(region) {
        var rt=region;
        //    console.log("rankinit");
        if (rt.length>0) {
            //        console.log("ranking stream init...");
            var rankric=rt.attr("chain");
            var startfid=rt.attr("startfid");
            var nextfid=rt.attr("nextfid");
            var numfid=rt.attr("numfid");
            var lsfid=rt.attr("lsfid");
            var rf1fid=rt.attr("rf1fid");
            var rf2fid=rt.attr("rf2fid");
            var rf3fid=rt.attr("rf3fid");
            var opfid=rt.attr("opfid");
            var hcfid=rt.attr("hcfid");
            var hifid=rt.attr("hifid");
            var lofid=rt.attr("lofid");
            var tmfid=rt.attr("tmfid");
            var rservice=rt.attr("service");
            if (!rservice) {
                rservice=IDN_SERVICE;
            }
            var shownum=rt.attr("shownum");
            if (!shownum) {
                shownum=-1;
            }
            rankContextPath = rt.attr("context");
            if (!rankContextPath) {
                rankContextPath = '';
            }

            if (rankric) {
                //        rt.find(".stream").each(function() {
                //            subfid.push(parseInt($(this).attr("fid")));
                //        });
                //        subfid=[];
                subrankrics[rankric]=[];
                subranktables[rankric]=[];
                isrankclean[rankric]=false;
                initrankrics[rankric]=[];
                rankShowCounter[rankric]=0;

                //console.log(buildSubFid(startfid, 10, numfid, nextfid));

                desktop.subscribe(rservice, rankric, buildSubFid(startfid, 14, numfid, nextfid));
                //        console.log("subscribe ric: " + rankric + " fid: " + buildSubFid(startfid, 14, numfid, nextfid));

                //var rankobj = new RankObj(rankric, 0, 10, numfid, startfid, nextfid, rankric);
                subrankobjs[rankric]={
                    "ric":rankric,
                    "factor":0,
                    "service":rservice,
                    "size":14,
                    "numfid":numfid,
                    "startfid":startfid,
                    "nextfid":nextfid,
                    "lsfid":lsfid,
                    "rf1fid":rf1fid,
                    "rf2fid": rf2fid,
                    "rf3fid": rf3fid,
                    "opfid": opfid,
                    "hcfid": hcfid,
                    "hifid": hifid,
                    "lofid": lofid,
                    "tmfid": tmfid,
                    "parent":rankric,
                    "shownum":shownum
                };
                subrankrics[rankric].push(rankric);
                subranktables[rankric].push(region);
            }
        }
    }
    function tsinit(region) {
        var tss=region.find(".txdatalist");
        if (tss.length>0) {
            var ric=tss.attr("ric");
            var fid=tss.attr("fid");

            if (ric && fid) {
                if (tsfid[ric]==undefined) {
                    tsfid[ric]=[];
                }
                tsfid[ric].push(fid);

                desktop.subscribe(IDN_SERVICE, ric, parseInt(fid));
            }
        }
    }
    function newsinit() {
        var bar=$("#headline-bar");
        if (bar.length>0) {
            queryStr = bar.attr("querystr");
            if (queryStr != null && queryStr!="")
            {
                desktop.subscribe(winId, desktop.NEWS_SERVICE, queryStr);
            //        console.log("queryStr: " + queryStr);
            }
        }
    }
    function tick() {
        //      if (stop) {
        //tickstart = false;
        //        stop = false;
        //hl = 0;
        //        return;
        //      }

        var c=hl - tickStep;
        if (c < 0)
            c += tickStep + 1;
        /*
      if (flashStore["h" + c]!=undefined) {
          for (var t1 in flashStore["h" + c]) {
              flashStore["h" + c][t1].removeClass("h" + c);
          }
          flashStore["h" + c]=[];
      }
      if (flashStore["u" + c]!=undefined) {
          for (var t2 in flashStore["u" + c]) {
              flashStore["u" + c][t2].removeClass("u" + c);
          }
          flashStore["u" + c]=[];
      }
      if (flashStore["d" + c]!=undefined) {
          for (var t3 in flashStore["d" + c]) {
              flashStore["d" + c][t3].removeClass("d" + c);
          }
          flashStore["d" + c]=[];
      }
      $.each(upstyles, function(i, l) {
        if (flashStore[l + c]!=undefined) {
            for (var t4 in flashStore[l + c]) {
                flashStore[l + c][t4].removeClass(l + c);
            }
            flashStore[l + c]=[];
        }
      });
      $.each(downstyles, function(i, l) {
        if (flashStore[l + c]!=undefined) {
            for (var t5 in flashStore[l + c]) {
                flashStore[l + c][t5].removeClass(l + c);
            }
            flashStore[l + c]=[];
        }
      });
      $.each(defaultstyles, function(i, l) {
        if (flashStore[l + c]!=undefined) {
            for (var t6 in flashStore[l + c]) {
                flashStore[l + c][t6].removeClass(l + c);
            }
            flashStore[l + c]=[];
        }
      });
*/
//        $(".h" + c).removeClass("h" + c);
//        $(".u" + c).removeClass("u" + c);
//        $(".d" + c).removeClass("d" + c);

        var tickstr = ["s-", c, " uptick downtick"].join("");
        var chgstr = ["c-", c, " changed"].join("");
//        if (typeof(_currentpid)=="undefined") {
//            $([".s-", c].join("")).removeClass(tickstr);
//            $([".c-", c].join("")).removeClass(chgstr);
//        } else if (_currentpid!=null) {
//            var pid = ["#", _currentpid, "page"].join("");
//            $(pid).find([".s-", c].join("")).removeClass(tickstr);
//            $(pid).find([".c-", c].join("")).removeClass(chgstr);
//        } else {
//            $([".s-", c].join("")).removeClass(tickstr);
//            $([".c-", c].join("")).removeClass(chgstr);
//        }

        for (var r in posRefStore) {
            for (var f in posRefStore[r]) {
                for (var i in posRefStore[r][f]) {
                    if (posRefStore[r][f][i].is([".s-", c].join(""))) {
                        posRefStore[r][f][i].removeClass(tickstr)
                    }
                    if (posRefStore[r][f][i].is([".c-", c].join(""))) {
                        posRefStore[r][f][i].removeClass(chgstr)
                    }
                }
            }
        }

        //      $.each(upstyles, function(i, l) {
        //          $("." + l + c).removeClass(l + c);
        //      });
        //      $.each(downstyles, function(i, l) {
        //          $("." + l + c).removeClass(l + c);
        //      });
        //      $.each(defaultstyles, function(i, l) {
        //          $("." + l + c).removeClass(l + c);
        //      });

        if (hl==tickStep)
            hl=0;
        else
            hl++;

        // Continue?
        if (tickStarted) setTimeout(tick, tickSleep);
    }
    function pad(n)
    {
        return (n<10 ? ["0", n].join("") : n);
    }
    function buildSubFid(sfid, size, numfid, nextfid) {
        var rfids=new Array();
        for (var i=0; i<size; i++) {
            rfids.push(parseInt(sfid)+i);
        }
        if (numfid!=null) {
            rfids.push(parseInt(numfid));
        }
        if (nextfid!=null) {
            rfids.push(parseInt(nextfid));
        }
        return rfids;
    }
    function buildRowData(rank, ric, rankobj, rowdata) {
        if (rowdata) {
            rowdata.rk=rank;
            rowdata.fidmap.rf1=rankobj.rf1fid;
            rowdata.fidmap.rf2=rankobj.rf2fid;
            rowdata.fidmap.rf3=rankobj.rf3fid;

            return rowdata;
        //          return {
        //            ric: ric,
        //            symbol: $existrow.find(".col_ticker").text(),
        //            nm: $existrow.find(".col_name").children().text(),
        //            assettype: $existrow.attr("assettype"),
        //            cc: $existrow.attr("cc"),
        //            ls: $existrow.find("[fid='" + rankobj.lsfid + "']").text(),
        //            rf1: $existrow.find("[fid='" + rankobj.rf1fid + "']").text(),
        //            rf2: $existrow.find("[fid='" + rankobj.rf2fid + "']").text(),
        //            rf3: $existrow.find("[fid='" + rankobj.rf3fid + "']").text(),
        //            tm: $existrow.find("[fid='" + rankobj.tmfid + "']").text(),
        //            op: $existrow.find("[fid='" + rankobj.opfid + "']").text(),
        //            hi: $existrow.find("[fid='" + rankobj.hifid + "']").text(),
        //            lo: $existrow.find("[fid='" + rankobj.lofid + "']").text(),
        //            hc: $existrow.find("[fid='" + rankobj.hcfid + "']").text(),
        //            fidmap: {
        //                ls: rankobj.lsfid,
        //                rf1: rankobj.rf1fid,
        //                rf2: rankobj.rf2fid,
        //                rf3: rankobj.rf3fid,
        //                op: rankobj.opfid,
        //                hc: rankobj.hcfid,
        //                hi: rankobj.hifid,
        //                lo: rankobj.lofid,
        //                tm: rankobj.tmfid
        //            },
        //            rk: rank
        //          }
        } else {
            return {
                ric: ric,
                //            symbol: ric,
                //            nm: ric,
                fidmap: {
                    ls: rankobj.lsfid,
                    rf1: rankobj.rf1fid,
                    rf2: rankobj.rf2fid,
                    rf3: rankobj.rf3fid,
                    op: rankobj.opfid,
                    hc: rankobj.hcfid,
                    hi: rankobj.hifid,
                    lo: rankobj.lofid,
                    tm: rankobj.tmfid
                },
                rk: rank
            }
        }
    }
    function setCMData(row, r, n) {
        // Handle the Item Context Menu, if needed... assuming the <tr> is the ".icmtrigger"
        var cmdata = row.data("contextmenu");
        if (cmdata) {
            var ric = r;
            var name = "";
            if (n != undefined) name = n;

            cmdata.ric = ric;
            cmdata.name = name;

            // Also for the chart info, if chart related context menu is required...
            if (cmdata.showchartchoices) {
                cmdata.chartinfo.ric = ric;
                if (row.attr("caption")) {
                    cmdata.chartinfo.caption = name;
                }
            //cmdata.chartcompareinfo.addRic = ric;
            }

            row.attr("data-contextmenu", JSON.stringify(cmdata));

            if (window["setCustomRStreamItemContextMenu"]) {
                window["setCustomRStreamItemContextMenu"](row);
            }
            else {
                desktop.setItemContextMenu(row, winId);
            }
        }
    }
    function translateTone(ric, input) {
        var output="";
        if (ric.indexOf(".OS")>-1) {
            if (input=="S") output="特";
            else if (input=="A") output="注";
            else if (input=="*") output="*";
            else if (input=="Y") output="Y";
            else if (input=="O") output="";
            else if (input=="X") output="";
            else if (input=="B") output="";
            else if (input=="G") output="";
        } else {
            if (input=="S") output="特";
            else if (input=="A") output="連";
            else if (input=="*") output="";
            else if (input=="Y") output="";
            else if (input=="P") output="前";
            else if (input=="O") output="前";
            else if (input=="X") output="T";
            else if (input=="B") output="R";
            else if (input=="G") output="";
            else if (input=="W") output="W";
        }
        return output;
    }
    function translateTradeTone(ric, input, pricecode) {
        var output=input;
        pricecode=$.trim(pricecode);
        if (input=="H") output="S高";
        else if (input=="L") output="S安";
        else if (input=="P") output="";
        else if (input=="#") {
            if (pricecode=="SS") output="ｼｽ停";
            else if (pricecode=="TS") output="一停";
            else if (ric.indexOf(".OS")>-1 && pricecode=="SP") output="";
            else if (pricecode=="SP") output="中断";
            else if (ric.indexOf(".OS")>-1 && pricecode=="ST") output="留保";
            else if (pricecode=="ST") output="板寄";
            else if (pricecode=="SB") output="";
            else if (pricecode=="CB") output="";
        }
        return output;
    }
    function translateFutureTradeTone(ric, input, pricecode) {
        var output=input;
        pricecode=$.trim(pricecode);
        if (pricecode!="") {
            if (pricecode=="TS") output="一停";
            else if (pricecode=="TH") output="取停";
            else if (pricecode=="SB") output="SB";
            else if (pricecode=="CB") output="CB";
            else output=pricecode;
        } else if (input=="P") output="前";
        return output;
    }
    function translateUnit(input) {
        var output="";
        input=$.trim(input);
        if (input=="x100") output="百";
        else if (input=="x1000") output="千";
        else if (input=="x10000") output="万";
        else if (input=="x1M") output="百万";
        else output=input;
        return output;
    }
    function processRic(ric) {
        //      if (ric.match(".HK$") || ric.match(".O$") || ric.match(".SS$") || ric.match(".SZ$") ||
        //          ric.match(".JK$") || ric.match(".KS$") || ric.match(".KQ$") || ric.match(".KL$") ||
        //          ric.match(".PS$") || ric.match(".SI$") || ric.match(".BK$") || ric.match(".TW$") ||
        //          ric.match(".HM$") || ric.match(".K$") || ric.indexOf(".") == -1) {
        //          return "/"+ric;
        //      } else {
        return ric;
    //      }
    }
    function translateShortSell(ric, input, pricecode) {
        var output=input;
        pricecode=$.trim(pricecode);
        if (pricecode=="N") output="";
            else if (pricecode=="E") output="空売規制中";
            else if (pricecode=="A") output="空売規制発動";
            else if (pricecode=="NA") output="空売規制解除";
            else output=pricecode;
        return output;
    }

    function translateUSNetChange(ric, input, irgprc , saltim ,trdprc,hst_close,dp) {
        var output=input;
        if (fidValStore[ric]==undefined) {
            fidValStore[ric]=[];
        }
        if (hst_close != undefined ){
            fidValStore[ric][21] = hst_close;
        }
        if (trdprc != '0' && trdprc != '-' && trdprc != "-0.00" && trdprc != "" &&  trdprc != undefined){
            fidValStore[ric][6] = trdprc;
        }
//        if (trdprc != 'undefined' ){
//            FidValStore[ric][6] = trdprc;
//        }

        irgprc= $.trim(irgprc).replace(/,/g,'');
        //saltim= $.trim(saltim);
        fidValStore[ric][6]= $.trim(fidValStore[ric][6]).replace(/,/g,'');
        fidValStore[ric][21] = $.trim(fidValStore[ric][21]).replace(/,/g,'');
        if (irgprc== '0' || irgprc == '-'){
            return '-';
        }else{
        if (trdprc == '0' || trdprc == '-' || trdprc == "-0.00" || trdprc == "" || trdprc == undefined){
            output =  parseFloat(irgprc) - parseFloat(fidValStore[ric][21]);
        }else{
            output =  parseFloat(irgprc) - parseFloat(fidValStore[ric][6]);
        }
        }

//        if (saltim.replace((/(?=:)|(?=,)/),'')> 200000){
//            output =  parseFloat(irgprc) - parseFloat(trdprc);
//        }
        if (isNaN(output)){
            return '-';
        }else{
            return output.toFixed(dp);
        }
    }


    function translateUSPctChange(ric, input, irgprc , saltim ,trdprc,hst_close) {
        var output=input;
        if (fidValStore[ric]==undefined) {
            fidValStore[ric]=[];
        }
        if (hst_close != undefined ){
            fidValStore[ric][21] = hst_close;
        }
        if (trdprc != '0' && trdprc != '-' && trdprc != "-0.00" && trdprc != "" &&  trdprc != undefined){
            fidValStore[ric][6] = trdprc;
        }
        irgprc=$.trim(irgprc).replace(/,/g,'');
        //saltim = $.trim(saltim);
        fidValStore[ric][6]= $.trim(fidValStore[ric][6]).replace(/,/g,'');
        fidValStore[ric][21] = $.trim(fidValStore[ric][21]).replace(/,/g,'');
         if (irgprc== '0' || irgprc == '-'){
            return '-';
        }else{
        if (trdprc == '0' || trdprc == '-' || trdprc == "-0.00" || trdprc == "" || trdprc == undefined){
            output =  ((parseFloat(irgprc) - parseFloat(fidValStore[ric][21]))*100)/ parseFloat(fidValStore[ric][21]);
        }else{
            output =  ((parseFloat(irgprc) - parseFloat(fidValStore[ric][6]))*100)/parseFloat(fidValStore[ric][6]);
        }
        }
//        if (saltim.replace((/(?=:)|(?=,)/),'')> 200000){
//            output =  (parseFloat(irgprc) - parseFloat(trdprc))/parseFloat(trdprc);
//        }
        if (isNaN(output)){
            return '-';
        }else{
//            var o = new NumberFormat();
//            o.setNumber(output);
//            o.setPercentage(true);
//            o.setPlaces(2, false);
            return output.toFixed(2);
        }
    }

   function translateUSNetChangefuture(ric, input, netchange ,acttp) {
        var output=input;
        if (fidValStore[ric]==undefined) {
            fidValStore[ric]=[];
        }
        if (netchange != '-' && netchange != "" &&  netchange != undefined){
            fidValStore[ric][275] = netchange;
        }

        if (acttp != undefined){
            fidValStore[ric][270] = acttp;
        }

        netchange= $.trim(netchange).replace(/,/g,'');
        fidValStore[ric][275]= $.trim(fidValStore[ric][275]).replace(/,/g,'');
        // 270 is equal PS return "-"
        if ("PS"==fidValStore[ric][270]){
            return '-';
        }else{
            output =  fidValStore[ric][275];
        }


        if (isNaN(output)){
            return '-';
        }else{
            return output;
        }
    }

   function translateUSPCTChangefuture(ric, input, pctchange ,acttp) {
        var output=input;
        if (fidValStore[ric]==undefined) {
            fidValStore[ric]=[];
        }
        if (pctchange != '-' && pctchange != "" &&  pctchange != undefined){
            fidValStore[ric][56] = pctchange;
        }

        if (acttp != undefined){
            fidValStore[ric][270] = acttp;
        }

        pctchange= $.trim(pctchange).replace(/,/g,'');
        fidValStore[ric][56]= $.trim(fidValStore[ric][56]).replace(/,/g,'');
        // 270 is equal PS return "-"
        if ("PS"==fidValStore[ric][270]){
            return '-';
        }else{
            output =  fidValStore[ric][56];
        }


        if (isNaN(output)){
            return '-';
        }else{
            return output;
        }
    }

    //Chnage the time to GMT
    function translateSalTim(saltim) {
        var output=saltim;
        var t;
        t=Date.parseExact(saltim, "HH:mm:ss"); // parse with expected date format
        if (t) {
             var fmtedtime = saltim;
             t.add(boot.TZ_LOCAL_OFFSET);
             output=t.toString("HH:mm");
        }
       return output;
    }


    function process(obj, value, fids, fid, skipalert) {
//    function process(obj, value, items, fids, fid) {
        skipalert = (typeof skipalert === 'undefined') ? false : skipalert;
        var oval=obj.html();
        value=$.trim(value);
        var ric=obj.attr("ric");
        var nval=value;
//        var ustyle=obj.attr("flashupstyle");
//        var dstyle=obj.attr("flashdownstyle");
//        var dfstyle=obj.attr("flashstyle");
//        var dblcolor=obj.attr("dblcolorflash");
//        var udcolor=obj.attr("trendcolor");
        var tick=obj.attr("tick");
        var tone=obj.attr("tone");
        var tradetone=obj.attr("tradetone");
        var isfuture=obj.attr("isfuture");
        var unit=obj.attr("unit");
        var tooltip=obj.attr("tooltip");
        var shortsell=obj.attr("shortsell");
        var us_afmktnc=obj.attr("us_afmktnc");
        var us_afmktpc=obj.attr("us_afmktpc");
        var us_afmktsaltim = obj.attr("us_afmktsaltim");
        var us_futurenc = obj.attr("us_futurenc");
        var us_futurepct = obj.attr("us_futurepct");
        var dp = obj.attr("dp");
        var cls="";
//        if (dblcolor=="true" && !ustyle) {
//            ustyle = "u";
//        }
//        if (dblcolor=="true" && !dstyle) {
//            dstyle = "d";
//        }

        // trendcolor
        //    if (udcolor=="true") {
        if (value > 0 || value.replace(/^B/ig, "")=='Þ' || value.replace(/^B/ig, "")=='⇧') {
            //        obj.removeClass("s-downcolor").addClass("s-upcolor");
            obj.removeClass("downval").addClass("upval");
        } else if (value < 0 || value.replace(/^B/ig, "")=='þ' || value.replace(/^B/ig, "")=='⇩') {
            //        obj.removeClass("s-upcolor").addClass("s-downcolor");
            obj.removeClass("upval").addClass("downval");
        } else {
            //        obj.removeClass("s-upcolor").removeClass("s-downcolor");
            obj.removeClass("upval").removeClass("downval");
        }
        //    }
        if (obj.data("curcls")) {
            obj.removeClass(obj.data("curcls"));
        }

/*Formatting starts here*/
/*
        var tfmt = obj.attr("format");
        // number formatting
        if (obj.attr("noformat")=="true" || tick=="true" || tone=="true" || unit=="true" || us_afmktnc=="true" || us_afmktpc=="true" || us_afmktsaltim == "true" || us_futurenc == "true" || us_futurepct == "true") {
            var fmtedval = value;
            if (obj.attr("nozero")=="true" && parseFloat(value)==0) {
                fmtedval = zeroReplacement;
                nval='';
            } else if (tick=="true") {
                value = value.replace(/B/ig, "");
                if (value=='Þ' || value=='⇧') {
                    //                fmtedval="&uarr;";
                    fmtedval="";
                } else if (value=='þ' || value=='⇩') {
                    //                fmtedval="&darr;";
                    fmtedval="";
                } else {
                    fmtedval=value;
                }
            } else if (tone=="true") {
                fmtedval=translateTone(ric, value);
            } else if (tradetone=="true") {
                if (isfuture=="true") {
                    fmtedval=translateFutureTradeTone(ric, value, fids[118]);
                } else {
                    fmtedval=translateTradeTone(ric, value, fids[118]);
                }
            } else if (unit=="true") {
                fmtedval=translateUnit(value);
            } else if (shortsell=="true") {
                fmtedval=translateShortSell(ric, value, fids[806]);
            }else if (us_afmktnc=="true") {
                fmtedval=translateUSNetChange(ric, value, fids[372],fids[379],fids[6],fids[21],dp);
                if (!isNaN(fmtedval)){
                    if (Number(fmtedval) > 0) {
                        obj.removeClass("downval").addClass("upval");
                        fmtedval = '+'+fmtedval;
                    }
                    else if ((fmtedval.startsWith('-') && fmtedval.length > 1) ||( Number(fmtedval) < 0)) {
                        obj.removeClass("upval").addClass("downval");
                    }
                    else {
                        obj.removeClass("upval").removeClass("downval");
                    }
                }else{
                    obj.removeClass("upval").removeClass("downval");
                }
            }else if (us_afmktpc=="true") {
                fmtedval=translateUSPctChange(ric, value, fids[372],fids[379],fids[6],fids[21]);
                if (!isNaN(fmtedval)){
                    var tmp = Number(fmtedval);
                    if (tmp > 0) {
                        obj.removeClass("downval").addClass("upval");
                        fmtedval = '+'+fmtedval+'%';
                    }
                    else if ((fmtedval.startsWith('-') && fmtedval.length > 1) ||tmp < 0) {
                        obj.removeClass("upval").addClass("downval");
                        fmtedval = fmtedval+'%';
                    }
                    else {
                        obj.removeClass("upval").removeClass("downval");
                        if (tmp == 0){
                            fmtedval = fmtedval+'%';
                        }
                    }
                }else{
                    obj.removeClass("upval").removeClass("downval");
                    //fmtedval = fmtedval+'%';
                }

            }else if (us_afmktsaltim =="true"){
                fmtedval=translateSalTim(fids[379]);
            }else if (us_futurenc == "true"){
                fmtedval=translateUSNetChangefuture(ric, value, fids[275],fids[270]);
                if (!isNaN(fmtedval)){
                    if (Number(fmtedval) > 0) {
                        obj.removeClass("downval").addClass("upval");
                    }
                    else if ( Number(fmtedval) < 0) {
                        obj.removeClass("upval").addClass("downval");
                    }
                    else {
                        obj.removeClass("upval").removeClass("downval");
                    }
                    
                    var output = new NumberFormat();
                    output.setNumber(fmtedval);
                    if (obj.is(".change")) {
                        output.setPositiveSign(true);
                    }
                    if (obj.attr("noseparator")=="true") {
                        output.setSeparators(false, ',', ',');
                    }
                    if (obj.attr("percentage")=="true") {
                        output.setPercentage(true);
                        output.setPlaces(2, false);
                    }
                    var dp = obj.attr("dp");
                    if (dp) {
                        output.setPlaces(parseInt(dp), false);
                    }
                    obj.empty().append(output.toFormatted());
                    if (tooltip=="true") {
                        obj.attr("title", output.toFormatted());
                    }
                    fmtedval=output.toFormatted();
                    
                }else{
                    obj.removeClass("upval").removeClass("downval");
                    fmtedval = '-';
                }

            } else if (us_futurepct == "true"){
                fmtedval=translateUSPCTChangefuture(ric, value, fids[56],fids[270]);
                if (!isNaN(fmtedval)){
                    var tmp = Number(fmtedval);
                    if (tmp > 0) {
                        obj.removeClass("downval").addClass("upval");
                    }
                    else if (tmp < 0) {
                        obj.removeClass("upval").addClass("downval");
                    }
                    else {
                        obj.removeClass("upval").removeClass("downval");
                    }
                    
                    var output = new NumberFormat();
                    output.setNumber(fmtedval);
                    if (obj.is(".change")) {
                        output.setPositiveSign(true);
                    }
                    if (obj.attr("noseparator")=="true") {
                        output.setSeparators(false, ',', ',');
                    }
                    if (obj.attr("percentage")=="true") {
                        output.setPercentage(true);
                        output.setPlaces(2, false);
                    }
                    var dp = obj.attr("dp");
                    if (dp) {
                        output.setPlaces(parseInt(dp), false);
                    }
                    obj.empty().append(output.toFormatted());
                    if (tooltip=="true") {
                        obj.attr("title", output.toFormatted());
                    }
                    fmtedval=output.toFormatted();
                    
                }else{
                    obj.removeClass("upval").removeClass("downval");
                    //fmtedval = fmtedval+'%';
                    fmtedval = '-';
                }

            }
            obj.empty().append(fmtedval);
            if (tooltip=="true") {
                obj.attr("title", fmtedval);
            }
            if (nval!='') {
                nval=fmtedval;
            }
        //    } else if (obj.attr("timefmt")) {
        } else if (tfmt=="date" || tfmt=="time" || tfmt=="timenoreplace") {
            var isClosingRun=(fids[6]!=undefined && parseFloat(fids[6])==0);
            // replace TRDTIM_1(18) fid with HSTCLSDATE(79) fid for closing run period
            if (fid==18 && isClosingRun) {
                if (tfmt=="timenoreplace") {
                    value="";
                    obj.empty().append("");
                    nval="";
                } else {
                    value=fids[79];
                }
            } else if (fid==16 && isClosingRun) {
                value=fids[79];
            }
            // hide TRADE_DATE(16) fid for closing run period
            //        } else if (fid==16 && isClosingRun) {
            //            value="";
            //            obj.empty().append(value);
            //            nval=value;
            //        }

            var t;
            var pattern=obj.attr("pattern");

            if (tfmt=="date" && pattern) { // special checking if format==date and pattern is given
                t=Date.parseExact(value, "dd MMM yyyy"); // parse with expected date format
                if (t==null) {
                    t=Date.parseExact(value, "MMM yyyy"); // try date format without day, force the pattern to become "yyyy/MM"
                    pattern = FORMMTPATTERN_TRADE_DATE_LONGYM; //"yyyy/MM"
                    if (t==null) {
                        t=Date.parse(value);
                    }
                }
            } else {
                t=Date.parse(value);
            }

            if (t) {
                var fmtedtime = value;
//                if (typeof(timeoffset)=="undefined") timeoffset = boot.TZ_LOCAL_OFFSET;
//                t.addHours(timeoffset);
                t.add(boot.TZ_LOCAL_OFFSET);

                // When there is "timeref" to be used for the date/time processing, value "t" is probably a pure date (without the time portion), hence need to process the timeref value to determine the correct date with timezone consideration
                var timeref = obj.attr("timeref");
                if (timeref!=null && !isClosingRun) {
                    if (fids[timeref]!=null) {
//                        var t2 = Date.parse(fids[timeref]);
//                        if (t2.getHours() + timeoffset >= 24) {
//                            t.addDays(1);
//                        }
//                        var t2 = Date.parse(fids[timeref]).add(boot.TZ_LOCAL_OFFSET).clearTime();
                        var t2 = Date.parse(t.toDateString() + " " + fids[timeref]).add(boot.TZ_LOCAL_OFFSET).clearTime();
                        var t1 = t.clone().clearTime();
                        if (t2.equals(t1)) {
                            // nop~ ... check this here to shortcut the testing logic assuming for most time, for the date portion, t1 == t2
                        }
                        else if (t2.isAfter(t1)) {
                            t.addDays(1);
                        }
                        else if (t2.isBefore(t1)) {
                            t.addDays(-1);
                        }
                    }
                }

                var fmt=timefmt;
                if (tfmt=="date" || (fid==18 && isClosingRun)) {
                    fmt=datefmt;
                }
                if (pattern) {
                    fmt=pattern;
                }
                fmtedtime=t.toString(fmt);
                obj.empty().append(fmtedtime);
                if (tooltip=="true") {
                    obj.attr("title", fmtedtime);
                }
                nval=fmtedtime;
            }
        //    } else if (obj.is(".time") || obj.attr("timefmt")) {
        //        //console.log(value);
        //        var t=Date.parse(value);
        //        //console.log(t);
        //        if (t) {
        //            var fmtedtime = value;
        //            if (typeof(timeoffset)=="undefined") timeoffset = boot.TZ_LOCAL_OFFSET;
        //            t.addHours(timeoffset);
        //
        //            var timeref = obj.attr("timeref");
        //            if (timeref!=null) {
        ////                console.log(fids[timeref]);
        ////                console.log(Date.parse(fids[timeref]));
        //                if (fids[timeref]!=null) {
        //                  var t2 = Date.parse(fids[timeref]);
        ////                  console.log(t2.getHours() + timeoffset);
        //                  if (t2.getHours() + timeoffset >= 24) {
        //                      t.addDays(1);
        //                  }
        //                }
        //            }
        //
        //            var fmt = obj.attr("timefmt");
        //            if (fmt==null) {
        //                fmt = "HH:mm";
        //            }
        //            fmtedtime=t.toString(fmt);
        //            obj.empty().append(fmtedtime);
        //            if (tooltip=="true") {
        //                obj.attr("title", fmtedtime);
        //            }
        //            nval=fmtedtime;
        //        }
        } else {
            // replace changed related field to '-' for closing run period'
            if (fids[6] && parseFloat(fids[6])==0 && ((obj.is(".change") && !obj.is(".sign")) || fid==32)) {
                obj.empty().append(zeroReplacement).removeClass("upval").removeClass("downval");;
                nval='';
            } else if (obj.attr("nozero")=="true" && parseFloat(value)==0) {
                obj.empty().append(zeroReplacement).removeClass("upval").removeClass("downval");;
                nval='';
                // make other fields that is reference to this field become nozero

//                items.filter(["[nozeroref='", fid, "']"].join("")).each(function() {
//                    obj.empty().append(zeroReplacement);
//                });

                if (posRefStore[ric]!=undefined) {
                    for (var f in posRefStore[ric]) {
                        for (var ref in posRefStore[ric][f]) {
                            posRefStore[ric][f][ref].filter(["[nozeroref='", fid, "']"].join("")).each(function() {
                                obj.empty().append(zeroReplacement);
                            });
                        }
                    }
                }

            } else if (obj.attr("nozeroref") && parseFloat(fids[obj.attr("nozeroref")])==0) {
                obj.empty().append(zeroReplacement).removeClass("upval").removeClass("downval");;
                nval='';
            } else {
                // EITS 0017717: [Price Quote] China Index/Equity
                if (fid == 6 && (ric.endsWith(".SS") || ric.startsWith(".SSE") || ric=='.CSI300' || ric.endsWith(".TW") || ric=='.TWII' || ric.endsWith(".BK") || ric=='.SETI')) {
                    if (fids[3372]!=null && parseFloat(fids[3372])!=0) {
                        value = fids[3372];
                    }
                    else if (fids[6]!=null && parseFloat(fids[6])!=0) {
                        value = fids[6];
                    }
                    else if (fids[1465]!=null && parseFloat(fids[1465])!=0) {
                        value = fids[1465];
                    }
                    else {
                        value=fids[21];
                    }
                }
                
                // check if it is a price field and it is under closing run period, replace TRDPRC_1(6) fid with HST_CLOSE(21) fid
                if (fid==6 && parseFloat(value)==0) {
                    value=fids[21];
                }
                //
                if (fid==6 && parseFloat(value)==0) {
                    obj.empty().append(zeroReplacement).removeClass("upval").removeClass("downval");;
                    nval='';
                } else {
                    var output = new NumberFormat();
                    output.setNumber(value);
                    //        if (obj.attr("positivesign")=="true") {
                    if (obj.is(".change")) {
                        output.setPositiveSign(true);
                    }
                    if (obj.attr("noseparator")=="true") {
                        output.setSeparators(false, ',', ',');
                    }
                    if (obj.attr("percentage")=="true") {
                        //        if (obj.is(".col_pctchange")) {
                        output.setPercentage(true);
                        output.setPlaces(2, false);
                    }
//                    if (obj.attr("parenthesis")=="true") {
//                        output.setNegativeFormat(output.PARENTHESIS);
//                    }
                    var dp = obj.attr("dp");
                    if (dp) {
                        output.setPlaces(parseInt(dp), false);
                    }
                    obj.empty().append(output.toFormatted());
                    if (tooltip=="true") {
                        obj.attr("title", output.toFormatted());
                    }
                    nval=output.toFormatted();
                }
            }
        }
*/
/*Formatting ends here*/
		obj.empty().append(value);	// XXXX Skip value formatting

        if (nval.length>0) {
            //remove thousand seperator, remove %
            nval = nval.replace(/,/g, '').replace(/%/g, '');
        }

        if (oval.length>0) {
            //remove thousand seperator, remove %
            oval = oval.replace(/,/g, '').replace(/%/g, '');
            //make it become negative if parenthesis found
            if (oval.indexOf("(") > -1 && oval.indexOf(")") > -1) {
                oval = ["-", oval.replace(/\(/g, '').replace(/\)/g, '')].join("");
            }
            if (oval=='-' || oval==zeroReplacement) {
                oval = '';
            }
            //compare value
            if (nval == oval || nval - oval == 0){
                cls="";
            } else if ((tick=="true" && nval=='&uarr;') || nval - oval > 0) {
//                if (ustyle) {
//                    cls=ustyle + hl;
//                } else if (dfstyle) {
//                    cls=dfstyle + hl;
//                }
                if (obj.is(".bid") || obj.is(".price") || obj.is(".change")) {
                    cls=["uptick s-", hl].join("");
                } else {
                    cls=["changed c-", hl].join("");
                }
            } else if ((tick=="true" && nval=='&darr;') || nval - oval < 0) {
//                if (dstyle) {
//                    cls=dstyle + hl;
//                } else if (dfstyle) {
//                    cls=dfstyle + hl;
//                }
                if (obj.is(".bid") || obj.is(".price") || obj.is(".change")) {
                    cls=["downtick s-", hl].join("");
                } else {
                    cls=["changed c-", hl].join("");
                }
            }
        } else {
            cls="";
        }

        if (obj.attr("noflash")!="true" && oval.length>0 && cls!="") {
            obj.addClass(cls);
            if (obj.attr("flashfid")) {
                var ffids=obj.attr("flashfid").split(" ");
                for (var ff in ffids) {
//                    items.filter(["[fid='", ffids[ff], "']"].join("")).each(function() {
//                        var $this = $(this);
//                        if (cls.indexOf("changed")<0) {
//                            $this.attr("class", $this.attr("class").replace(/\bs-.\d?\b/g, '')).removeClass("uptick downtick");
//                        }
//                        $this.addClass(cls);
//                    });

                    if (posRefStore[ric]!=undefined) {
                        for (var prs_fid in posRefStore[ric]) {
                            for (var ref in posRefStore[ric][prs_fid]) {
                                posRefStore[ric][prs_fid][ref].filter(["[fid='", ffids[ff], "']"].join("")).each(function() {
                                    var $this = $(this);
                                    if (cls.indexOf("changed")<0) {
                                        $this.attr("class", $this.attr("class").replace(/\bs-.\d?\b/g, '')).removeClass("uptick downtick");
                                    }
                                    $this.addClass(cls);
                                });
                            }
                        }
                    }
                }
            }
            if (obj.attr("flashdiv")) {
                var fdivs=obj.attr("flashdiv").split(" ");
                for (var fd in fdivs) {
//                $("[id='" + fdivs[fd] + "']").each(function() {
//                    items.filter(["[id='", fdivs[fd], "']"].join("")).each(function() {
//                        var $this = $(this);
//                        $this.attr("class", $this.attr("class").replace(/\bs-.\d?\b/g, '')).removeClass("uptick downtick");
//                        $this.addClass(cls);
//                    });

                    if (posRefStore[ric]!=undefined) {
                        for (var prs_fid in posRefStore[ric]) {
                            for (var ref in posRefStore[ric][prs_fid]) {
                                posRefStore[ric][prs_fid][ref].filter(["[id='", fdivs[fd], "']"].join("")).each(function() {
                                    var $this = $(this);
                                    $this.attr("class", $this.attr("class").replace(/\bs-.\d?\b/g, '')).removeClass("uptick downtick");
                                    $this.addClass(cls);
                                });
                            }
                        }
                    }
                }
            }
      /*
      if (flashStore[cls]==undefined) {
          flashStore[cls]=[];
      }
      flashStore[cls].push(obj);
      */
        }
        //    if (obj.is(".flash")) {
        //        obj.addClass("changed c-" + hl);
        //    }
        obj.data("curcls", cls);
    // special arrow feature
    //if (arrowreffid==fid) {
    //    arrowdiv.each(function() {
    //      obj.empty();
    //      if (value > 0) {
    //        obj.append("&uarr;").removeClass("s-downcolor").addClass("s-upcolor");
    //      } else if (value < 0) {
    //        obj.append("&darr;").removeClass("s-upcolor").addClass("s-downcolor");
    //      }
    //    });
    //}
        if (_ENABLE_PRICE_ALERT && ((report.gid)?($.inArray(report.gid, PRICE_ALERT_WHITELIST) > -1):false)){
            var pl_pattern = ric+"_"+fid;
            var _currentstreamingricfid_type = typeof _currentstreamingricfid;
            
            if (fidValStore[ric]==undefined) {
                fidValStore[ric] = [];
            }
            if(_currentstreamingricfid_type != 'undefined'){
                var index = $.inArray(pl_pattern, _currentstreamingricfid);
                if (index > -1){
                    var fid_td = "";
                    var fid_tm = "";
                    
                    if (fids[16] || fids[17]) {
                        // handle fids[16] or fids[17] equals to ' ' case
                        if (!($.trim(fids[16]) == "" && $.trim(fids[17]) == "")) {
                            if (fids[16]) {
                                fid_td = fids[16];
                            }
                            else {
                                fid_td = fids[17];
                            }
                            t=Date.parseExact(fid_td, "dd MMM yyyy"); // parse with expected date format
                            if (t==null) {
                                t=Date.parseExact(fid_td, "MMM yyyy"); // try date format without day, force the pattern to become "yyyy/MM"
                                pattern = FORMATPATTERN_TRADE_DATE_LONGYMD; //"yyyy/MM"
                                if (t==null) {
                                    t=Date.parse(fid_td);
                                }
                            }
                            fid_td = t.toString(FORMATPATTERN_TRADE_DATE_LONGYMD);
                            if (fids[16]) {
                                fidValStore[ric][16] = fid_td;
                            }
                            else {
                                fidValStore[ric][17] = fid_td;
                            }
                        }
//                        else {
//                            console.log("t is null - ric: "+ric+" | fids[16]: "+fids[16]+" | fids[17]: "+fids[17]+" | fids[18]: "+fids[18]+" | fids[5]: "+fids[5]+" | fidValStore[ric][16]: "+fidValStore[ric][16]+" | fidValStore[ric][17]: "+fidValStore[ric][17]+" | fid_tm"+fid_tm);
//                        }
                    }
                    if (fids[18] || fids[5]) {
                        // handle fids[18] or fids[5] equals to '  :  ' case
                        if ($.trim(fids[18]).length > 1 || $.trim(fids[5]).length > 1) {
                            if (fids[18]) {
                                fid_tm = fids[18];
                            }
                            else {
                                fid_tm = fids[5];
                            }
                            if (fidValStore[ric][16] || fidValStore[ric][17]) {
                                if (fidValStore[ric][16]) {
                                    t2 = Date.parse(fidValStore[ric][16] + " " + fid_tm);
                                }
                                else {
                                    t2 = Date.parse(fidValStore[ric][17] + " " + fid_tm);
                                }
                                if (t2) {
                                    t2.add(boot.TZ_LOCAL_OFFSET).clearTime();
                                    t1 = t2.clone().clearTime();
                                    if (t2.equals(t1)) {
                                        // nop~ ... check this here to shortcut the testing logic assuming for most time, for the date portion, t1 == t2
                                    }
                                    else if (t2.isAfter(t1)) {
                                        t2.addDays(1);
                                        fid_td = t2.toString(FORMATPATTERN_TRADE_DATE_LONGYMD);
                                    }
                                    else if (t2.isBefore(t1)) {
                                        t2.addDays(-1);
                                        fid_td = t2.toString(FORMATPATTERN_TRADE_DATE_LONGYMD);
                                    }
                                }
//                                else {
//                                    console.log("t2 is null - ric: "+ric+" | fids[16]: "+fids[16]+" | fids[17]: "+fids[17]+" | fids[18]: "+fids[18]+" | fids[5]: "+fids[5]+" | fidValStore[ric][16]: "+fidValStore[ric][16]+" | fidValStore[ric][17]: "+fidValStore[ric][17]+" | fid_tm"+fid_tm);
//                                }
                            }
                            else {
                                t2 = Date.parse(fid_tm).add(boot.TZ_LOCAL_OFFSET).clearTime();
                            }
                            t2=Date.parseExact(fid_tm, "HH:mm"); // parse with expected date format
                            t2.add(boot.TZ_LOCAL_OFFSET);
                            fid_tm=t2.toString(FORMATPATTERN_SALTIME_MD);
                        }
//                        else {
//                            console.log("fids[18] or fids[5] == ':' - ric: "+ric+" | fids[16]: "+fids[16]+" | fids[17]: "+fids[17]+" | fids[18]: "+fids[18]+" | fids[5]: "+fids[5]+" | fidValStore[ric][16]: "+fidValStore[ric][16]+" | fidValStore[ric][17]: "+fidValStore[ric][17]+" | fid_tm"+fid_tm);
//                        }
                    }
                    else {
                        
                    }
//                    if (!skipalert) {
//                        pricealertCheck(ric, fid, value, fid_td, fid_tm)
//                    }
                }
            }
        }
    }
    return {
        start : function() {
            init();
            if (!tickStarted) {
                //console.log("TICKKKKKKKKKKKKKKKKKK START !!!!!!!!!!!!!!!!!!!!!!!!!!!");
                tickStarted = true;
                tick();
            }
        },
        stream : function(region, data) {
            var $thisregion = $(["#", region.id].join(""));
            this.stream$($thisregion, data);
        },
        stream$ : function($thisregion, data) {
            //call react function here.
            window.streamingUpdate(data)

//////CONSOLELOGGER.info(JSON.stringify(data));
//////var _st = $.now();

// //            var $thisregion = $(["#", region.id].join(""));
//             for (var service in data)
//             {
//                 if (service == root.SYS_SERVICE)
//                 {
//                     // Only root is interested in SYS_SERVICE, other Streaming logic would ignore this service...
//                     // nop~
//                     continue;
//                 }
//                 else if (service == IDN_SERVICE)
//                 {
//                     // For non-NEWS_SERVICE...
//                     var rics = data[service];
//                     for (var ric in rics)
//                     {
// //                        console.log("sub: " + subrankrics);
//                         var robj=subrankobjs[ric];
//                         if (robj!=undefined && $.inArray(ric, subrankrics[robj.parent])>-1) {
//                             var $rankingtable=$thisregion.find([".rstream[chain='", robj.parent, "']"].join(""));

//                             //check whether the ranking list is cleaned due to closing run
//                             if (isrankclean[robj.parent]==true) {
//                                 if (ric==robj.parent && rics[ric][robj.numfid]!="0") {
//                                     //if yes, unsubscribe all the related ranking rics first
//                                     for (var n in subrankrics[robj.parent]) {
//                                         if (subrankrics[robj.parent][n]) {
//                                             desktop.unsubscribe(IDN_SERVICE, subrankrics[robj.parent][n]); //TODO: not hardcode service
//                                         //                                                  console.log("streaming.js - stream: unsubscribe ric: " + subrankrics[robj.parent][n] + " due to closing run 1");
//                                         }
//                                     }
//                                     //subscribe again
//                                     subrankrics[robj.parent]=[];
//                                     var cpage = $rankingtable.attr("cpage");
//                                     var subcat2 = $rankingtable.attr("subcat2");
//                                     var subcat3 = $rankingtable.attr("subcat3");
//                                     var subcat4 = $rankingtable.attr("subcat4");
//                                     var pn = $rankingtable.attr("pn");
//                                     var recperpage = $rankingtable.attr("recperpage");
//                                     var pstr = "";
//                                     var scstr = "";
//                                     var rankobj = {
//                                         cpage: cpage,
//                                         subcat2: subcat2,
//                                         subcat3: subcat3,
//                                         pn: pn,
//                                         recperpage: recperpage
//                                     };
//                                     if (subcat4) {
//                                         scstr = ["&subcat4=", subcat4].join("");
//                                         rankobj = {
//                                             cpage: cpage,
//                                             subcat2: subcat2,
//                                             subcat3: subcat3,
//                                             subcat4: subcat4,
//                                             pn: pn,
//                                             recperpage: recperpage
//                                         };
//                                     }
//                                     if (cpage && subcat2 && subcat3) {
//                                         $rankingtable.loadlistdata2("", ["rankinglistdata?listtype=stockranking&cpage=", cpage, "&subcat2=", subcat2, "&subcat3=", subcat3, scstr, "&pn=", pn, "&recperpage=", recperpage].join(""), {
//                                             isrank: true,
//                                             rankobj: rankobj
//                                         });
//                                         isrankclean[robj.parent]=false;
//                                     }
//                                 }
//                             } else {

// //                                        var robj=subrankobjs[ric];
//                                 var rfids=rics[ric];
//                                 if (rfids) {
//                                     var riclist = "";
// //                                            console.log("init: " + initrankrics);
//                                     var next=rfids[robj.nextfid];
                                    
//                                     //special workaround due to unexpected return for HK ranking
//                                     if (next==undefined) next = '';

// //                                            console.log("next: " + next);

//                                     if (initrankrics[robj.parent]==undefined) {
//                                         initrankrics[robj.parent]=[];
//                                     }
//                                     // check whether the ranking fid is already initialized and also the next fid is existed
//                                     if ($.inArray(ric, initrankrics[robj.parent])<0 && next!=undefined) {

//                                         //initalize ranking table
//                                         var size=rfids[robj.numfid];
// //                                                console.log('size ' + size);
//                                         robj.size = size;

//                                         var shownum=robj.shownum;

//                                         initrankrics[robj.parent].push(ric);

//                                         rankShowCounter[robj.parent]+=parseInt(size);

//                                         if ((rankShowCounter[robj.parent] >= shownum && shownum>-1) || size == 0) { // size is 0 means the ranking has no content, clear the next fid to avoid next chain processing
//                                             next = '';
//                                             if (size == 0 && ric==robj.parent) {
// //                                                        console.log("reset initrankrics 1");
//                                                 initrankrics[robj.parent]=[]; // reset the init rank list such that it can be initialize again
//                                                 isrankclean[robj.parent]=true;
//                                             }
//                                         }

//                                         if (next!='') {
//                                             //subscribe next chain ric
//                                             desktop.subscribe(robj.service, next, buildSubFid(robj.startfid, size, robj.numfid, robj.nextfid));
// //                                                    console.log('subscribed ric: ' + next + " fid: " + buildSubFid(robj.startfid, size, robj.numfid, robj.nextfid));
//                                             //var rankobj = new RankObj(next, robj.factor+1, size, robj.numfid, robj.startfid, robj.nextfid, robj.parent);

//                                             subrankobjs[next]={
//                                                 "ric":next,
//                                                 "factor":robj.factor+1,
//                                                 "service":robj.service,
//                                                 "size":size,
//                                                 "numfid":robj.numfid,
//                                                 "startfid":robj.startfid,
//                                                 "nextfid":robj.nextfid,
//                                                 "lsfid":robj.lsfid,
//                                                 "rf1fid":robj.rf1fid,
//                                                 "rf2fid":robj.rf2fid,
//                                                 "rf3fid":robj.rf3fid,
//                                                 "opfid":robj.opfid,
//                                                 "hcfid":robj.hcfid,
//                                                 "hifid":robj.hifid,
//                                                 "lofid":robj.lofid,
//                                                 "tmfid":robj.tmfid,
//                                                 "parent":robj.parent,
//                                                 "shownum":robj.shownum
//                                                 };
//                                             subrankrics[robj.parent].push(next);
//                                         }
//                                         else {

//                                             $rankingtable.listtable("getRowBySelector", ".datarow").find(".col").each(function() {
//                                                 var $this = $(this);
//                                                 if ($this.attr("ric") && $this.attr("fid")) {
//                                                     $this.addClass("stream flash");
//                                                     //store subscribed fid for later subscripion purpose
//                                                     var sfid=$this.attr("fid");
//                                                     if (sfid) {
//                                                         if ($.inArray(parseInt(sfid), subfid)<0) {
//                                                             subfid.push(parseInt(sfid));
//                                                         }
//                                                     }
//                                                 }
//                                             });
// //                                                    $rankingtable.listtable("getRowBySelector", ".datarow").find(".col").each(function() {
// //                                                        //add back streaming related class for streaming purpose
// //                                                        $(this).addClass("stream flash");
// //                                                        //store subscribed fid for later subscripion purpose
// //                                                        var sfid=$(this).attr("fid");
// //                                                        if (sfid) {
// //                                                            if ($.inArray(parseInt(sfid), subfid)<0) {
// //                                                                subfid.push(parseInt(sfid));
// //                                                            }
// //                                                        }
// //                                                    });
//                                             //start subscribe stock rics
//                                             quoteinit($rankingtable.listtable("getRowBySelector", ".datarow"));
//                                         }

//                                         //process other fids
//                                         for (var rfid in rfids) {
// //                                            var items=$thisregion.find([".stream[ric='", ric, "']"].join(""));
// //
// //                                            items.filter(["[fid='", rfid, "']"].join("")).each(function() {
// //                                                process($(this), rfids[rfid], items, rfids, rfid);
// //                                            });

//                                             if (posRefStore[ric]!=undefined) {
//                                                 if (posRefStore[ric][rfid]!=undefined) {
//                                                     for (var ref in posRefStore[ric][rfid]) {
//                                                         process(posRefStore[ric][rfid][ref], rfids[rfid], rfids, rfid);
//                                                     }
//                                                 }
//                                             }

//                                         }

//                                     } else {
//                                         //                                                console.log(rfids[robj.numfid]);
//                                         // check if the number of ranking item is 0, treat it as closing run, clear the ranking table
//                                         if (rfids[robj.numfid]==0 && ric==robj.parent) {
//                                             //                                                    console.log("closing run cleaning!!!");
//                                             $thisregion.find(".stream").each(function() {
//                                                 var $this = $(this);
//                                                 //                                                        var service=$this.attr("service");
//                                                 var ric=$this.attr("ric");
//                                                 var fid=$this.attr("fid");
//                                                 if (ric && fid) {
//                                                     desktop.unsubscribe(IDN_SERVICE, ric);
// //                                                            console.log("streaming.js - stream: unsubscribe ric " + ric + " due to closing run 2");
//                                                     if (fid==6) {
//                                                         desktop.unsubscribe(IDN_SERVICE, ric);
// //                                                                console.log("streaming.js - stream: unsubscribe ric " + ric + " becoz of fid 6 due to closing run 2");
//                                                     }
//                                                 }
//                                             });

//                                             $rankingtable.listtable("removeAllRows");

// //                                                    $thisregion.find(".rstream[ric='" + robj.parent + "'] div").each(function(index, value) {
// //                                                        if (index>0) {
// //                                                            $(this).remove();
// //                                                        }
// //                                                    });
// //                                                    console.log("reset initrankrics 2");
//                                             initrankrics[robj.parent]=[];
// //                                                    subrankrics[robj.parent]=[];
// //                                                    subrankrics[robj.parent].push(robj.parent);
//                                             isrankclean[robj.parent]=true;
//                                         } else {


//                                             //add/delete/swap ranking

// //                                                console.log("receive ranking update: " + ric);

//                                             var recycleObj = new Array();

// //                                                var tmplrow = $thisregion.find(".rstream[ric='" + robj.parent + "'] tr:first");
//                                             for (var rfid in rfids) {
// //                                                    console.log(robj.startfid);
// //                                                    console.log(robj.numfid);
// //                                                    console.log(buildSubFid(robj.startfid, robj.size, null, null));
//                                                 if ($.inArray(parseInt(rfid), buildSubFid(robj.startfid, robj.size, null, null))>-1) {
//                                                     var r=rfids[rfid];
//                                                     var sr=processRic(r);
// //                                                        var replacerow=true;
// //                                                        console.log("fid:" + rfid);
// //                                                        console.log("ric: " + r);

// //                                                        var existNode=$thisregion.find(".rstream[ric='" + robj.parent + "'] div[ric='" + r + "']");
//                                                     var rank=(robj.factor*subrankobjs[robj.parent].size)+parseInt(rfid)-robj.startfid+1;

//                                                     if (robj.shownum!=-1 && rank>robj.shownum) break;

//                                                     var $target=$rankingtable.listtable("getRow", rank-1);
//                                                     if ($target==null) {
//                                                         $target=$rankingtable.listtable("getRowBySelector", ":visible:last");
//                                                     }

//                                                     if (r=="") { //means remove the ric at target row
//                                                         recycleObj[$target.attr("ric")]=$target.detach();
//                                                     } else {
//                                                         var $existrow=$rankingtable.listtable("getRowBySelector", ["[ric='", r, "']"].join(""));
// //                                                        var $target=$rankingtable.listtable("getRowBySelector", "[rank='" + rank + "']");
// //                                                        var target=$thisregion.find(".rstream[ric='" + robj.parent + "'] div[rank='" + rank + "']");
// //                                                        console.log("new rank: " + rank);
// //                                                        console.log(existNode);
// //                                                        console.log(target);
//                                                         if ($existrow!=null && $existrow.length>0) {

//                                                             if ($existrow.attr("rank")!=rank) {
//                                                                 //                                                                console.log("swap place - target:" + rank);

//                                                                 //insert a dummy row to original place
//                                                                 $rankingtable.listtable("insertRowAt", parseInt($existrow.attr("rank")), null, false);

//                                                                 //detach existing row out
//                                                                 var $drow=$existrow.detach();
//                                                                 //update rank related info
//                                                                 $existrow.attr("rank", rank);
//                                                                 $drow.find(".col_rank").each(function() {
//                                                                     $(this).empty().append(rank);
//                                                                 });
//                                                                 //update background color
//                                                                 if (rank%2==0) {
//                                                                     $drow.addClass("oddrow").removeClass("evenrow");
//                                                                 } else {
//                                                                     $drow.addClass("evenrow").removeClass("oddrow");
//                                                                 }

//                                                                 //add to target place
//                                                                 $target.after($drow);
//                                                                 //detach the original row and store for later use
//                                                                 recycleObj[$target.attr("ric")]=$target.detach();

// //                                                                var $crow = $existNode.clone(true).show();
// //                                                                $crow.attr("rank", rank);
// //                                                                if (rank%2==0) {
// //                                                                    $crow.addClass("oddrow").removeClass("evenrow");
// //                                                                } else {
// //                                                                    $crow.addClass("evenrow").removeClass("oddrow");
// //                                                                }
// //                                                                $crow.find(".col_rank").each(function() {
// //                                                                   $(this).empty().append(rank);
// //                                                                });

// //                                                              var crow=existNode.clone(true).show();
// //                                                              crow.attr("rank", rank);
// //                                                              if (rank%2==0)
// //                                                                crow.addClass("even_row");
// //                                                              else
// //                                                                crow.removeClass("even_row");
// //
// //                                                              crow.find(".col_rank").each(function() {
// //                                                                 $(this).empty().append(rank);
// //                                                              });

// //                                                            console.log(crow);
// //                                                                $rankingtable.listtable("insertRowAfterBySelector", "[rank='" + rank + "']", buildRowData(rank, r, robj, $existNode), replacerow);
// //                                                                $rankingtable.listtable("getRowBySelector", "[rank='" + rank + "']").find(".col").each(function() {
// //                                                                   $(this).addClass("stream flash");
// //                                                                });
// //                                                                $target.after($crow);
// //                                                              $target.remove();
// //recycleRics.push(target.attr("ric"));
// //                                                              if (replacerow) {
// //                                                                recycleObj[$target.attr("ric")]=$target.detach();
// //                                                              }
// //console.log(recycleObj[target.attr("ric")]);
//                                                             }

//                                                         //crow.find(".stream").each(function() {
//                                                         //    var cs = $(this).attr("service");
//                                                         //    var cr = $(this).attr("ric")
//                                                         //    var cf = $(this).attr("fid")
//                                                         //    if (cs && cr && cf) {
//                                                         //                if (posRefStore[cs]==undefined) {
//                                                         //                    posRefStore[cs]=[];
//                                                         //                }
//                                                         //                if (posRefStore[cs][cr]==undefined) {
//                                                         //                    posRefStore[cs][cr]=[];
//                                                         //                }
//                                                         //                if (posRefStore[cs][cr][cf]==undefined) {
//                                                         //                    posRefStore[cs][cr][cf]=[];
//                                                         //                }
//                                                         //                posRefStore[cs][cr][cf].push($(this));
//                                                         //    }
//                                                         //});

//                                                         } else if (recycleObj[r]!=null) {
// //                                                            console.log("get from recycle - target:" + rank);
// //                                                            target = $(".rstream[ric='" + robj.parent + "'] tr[rank=" + rank + "]");
//                                                             recycleObj[r].attr("rank", rank);
//                                                             recycleObj[r].find(".col_rank").each(function() {
//                                                                 $(this).empty().append(rank);
//                                                             });
//                                                             if (rank%2==0) {
//                                                                 recycleObj[r].addClass("oddrow").removeClass("evenrow");
//                                                             } else {
//                                                                 recycleObj[r].addClass("evenrow").removeClass("oddrow");
//                                                             }

//                                                             $target.after(recycleObj[r]);
//                                                             recycleObj[r]=null;
//                                                             if ($target.attr("rank")) {
//                                                                 recycleObj[$target.attr("ric")]=$target.detach();
//                                                             } else {
//                                                                 $target.detach();
//                                                             }

// //                                                            if (replacerow) {
// //                                                                recycleObj[$target.attr("ric")]=$target.detach();
// //                                                            }
//                                                         } else {
// //                                                            console.log("new rank item - target:" + rank);

// //                                                            var newrow = tmplrow.clone(true).show();
// //                                                            var $newrow = $rankingtable.listtable("getRowBySelector", ":last").clone(true).show();

// //                                                            var nbind = newrow.attr("bind");
// //                                                            var nfn = newrow.attr("fn");
// //                                                            if (nbind && nfn) {
// //                                                                newrow.bind(nbind, {ric: r}, window[nfn]);
// //                                                            }

// //                                                            newrow.find(".rs").each(function() {
// //                                                                //alert('a');
// //                                                                $(this).attr("ric", sr);
// //                                                                $(this).addClass('stream');
// //                                                                $(this).attr("service", robj.service);
// //                                                            })
// //                                                            $newrow.find(".stream").each(function() {
// //                                                                $(this).attr("ric", sr);
// //                                                            });

// //                                                            $newrow.attr("ric", r);
// //                                                            newrow.find("#ric").each(function() {
// //                                                                var cb = $(this).attr("callback");
// //                                                                if (cb) {
// //                                                                    if (window[cb]) {
// //                                                                      $(this).empty().append(window[cb](r));
// //                                                                    }
// //                                                                } else {
// //                                                                  $(this).empty().append(r);
// //                                                                }
// //                                                            });

// //                                                            if (stockinfo[r]!=undefined) {
// //                                                                newrow.find("#ric").each(function() {
// //                                                                  var cb = $(this).attr("callback");
// //                                                                  if (cb) {
// //                                                                      if (window[cb]) {
// //                                                                        $(this).empty().append(window[cb](stockinfo[r].ticker, r, stockinfo[r].name));
// //                                                                        $(this).attr("title", window[cb](stockinfo[r].ticker, r, stockinfo[r].name));
// //                                                                      }
// //                                                                  } else {
// //                                                                    $(this).empty().append(r);
// //                                                                    $(this).attr("title", r);
// //                                                                  }
// //                                                                });
// //
// //                                                                newrow.find("#name").each(function() {
// //                                                                  var cb = $(this).attr("callback");
// //                                                                  if (cb) {
// //                                                                      if (window[cb]) {
// //                                                                        $(this).empty().append(window[cb](stockinfo[r].ticker, r, stockinfo[r].name));
// //                                                                      }
// //                                                                  } else {
// //                                                                    $(this).empty().append(stockinfo[r].name);
// //                                                                  }
// //                                                                  $(this).attr("title", stockinfo[r].name);
// //                                                                });
// //
// //                                                                newrow.each(function() {
// //                                                                      setCMData($(this), r, stockinfo[r].ticker + " " + stockinfo[r].name);
// //                                                                });
// //                                                            }

// //                                                            newrow.attr("rank", rank);
// //                                                            if (rank%2==0)
// //                                                              newrow.addClass("even_row");
// //                                                            else
// //                                                              newrow.removeClass("even_row");
// //                                                            newrow.find("#rank").each(function() {
// //                                                               $(this).empty().append(rank);
// //                                                            });
// //                                                            $newrow.attr("rank", rank);
// //                                                            if (rank%2==0) {
// //                                                                $newrow.addClass("oddrow").removeClass("evenrow");
// //                                                            } else {
// //                                                                $newrow.addClass("evenrow").removeClass("oddrow");
// //                                                            }
// //                                                            $newrow.find(".col_rank").each(function() {
// //                                                                $(this).empty().append(rank);
// //                                                            });
// //
// //                                                            //// TEMP
// //                                                            $newrow.find(".col_ticker").each(function() {
// //                                                                $(this).empty().append(r);
// //                                                            });
// //                                                            $newrow.find(".col_name").each(function() {
// //                                                                $(this).empty().append(r);
// //                                                            });
// //// TEMP

//                                                             recycleObj[$target.attr("ric")]=$target;
// //                                                            $rankingtable.listtable("insertRowAtBySelector", "[rank='" + rank + "']", buildRowData(rank, r, robj), replacerow);
//                                                             var row;
//                                                             if (stockinfo[r]!=undefined) {
//                                                                 row = buildRowData(rank, r, robj, stockinfo[r]);
//                                                             } else {
//                                                                 row = buildRowData(rank, r, robj);
//                                                             }
//                                                             $rankingtable.listtable("insertRowAt", rank-1, row, true);

// //                                                            $rankingtable.listtable("getRowBySelector", "[rank='" + rank + "']").find(".col").each(function() {
// //                                                               $(this).addClass("stream flash");
// //                                                            });
//                                                             $rankingtable.listtable("getRow", rank-1).find(".col").each(function() {
//                                                                 var $this = $(this);
//                                                                 var nric = $this.attr("ric");
//                                                                 var nfid = $this.attr("fid");
//                                                                 if (nric && nfid) {
//                                                                     $this.addClass("stream flash");
//                                                                     if (posRefStore[nric]==undefined) {
//                                                                         posRefStore[nric]=[];
//                                                                     }
//                                                                     if (posRefStore[nric][nfid]==undefined) {
//                                                                         posRefStore[nric][nfid]=[];
//                                                                     }
//                                                                     posRefStore[nric][nfid].push($this);
//                                                                 }
//                                                             });

// //                                                            $target.after($newrow);
// //                                                            $target.remove();

// //                                                            //target = $(".rstream[ric='" + robj.parent + "'] tr[rank=" + rank + "]");
// //                                                            target.after(newrow);
// //                                                            if (replacerow) {
// //                                                                recycleObj[$target.attr("ric")]=$target.detach();
// //                                                            }
//                                                             for (var sf in subfid) {
//                                                                 desktop.subscribe(robj.service, sr, subfid[sf]);
// //                                                                console.log("subscribe ric: " + sr + " fid: " + subfid);
//                                                                 if (subfid[sf]==6) {
//                                                                     desktop.subscribe(robj.service, sr, [21,79,3372,1465]);
//                                                                 }
//                                                             }

//                                                             //newrow.find(".stream").each(function() {
//                                                             //    var cs = $(this).attr("service");
//                                                             //    var cr = $(this).attr("ric")
//                                                             //    var cf = $(this).attr("fid")
//                                                             //    if (cs && cr && cf) {
//                                                             //                if (posRefStore[cs]==undefined) {
//                                                             //                    posRefStore[cs]=[];
//                                                             //                }
//                                                             //                if (posRefStore[cs][cr]==undefined) {
//                                                             //                    posRefStore[cs][cr]=[];
//                                                             //                }
//                                                             //                if (posRefStore[cs][cr][cf]==undefined) {
//                                                             //                    posRefStore[cs][cr][cf]=[];
//                                                             //                }
//                                                             //                posRefStore[cs][cr][cf].push($(this));
//                                                             //    }
//                                                             //});


//                                                             if (stockinfo[r]==undefined) {
//                                                                 if (riclist != "") {
//                                                                     riclist = [riclist, ","].join("");
//                                                                 }
//                                                                 riclist += r;
//                                                             }
//                                                         }
//                                                     }
//                                                 } else {
// //                                                    var items=$thisregion.find([".stream[ric='", ric, "']"].join(""));
// //
// //                                                    items.filter(["[fid='", rfid, "']"].join("")).each(function() {
// //                                                        process($(this), rfids[rfid], items, rfids, rfid);
// //                                                    });

//                                                     if (posRefStore[ric]!=undefined) {
//                                                         if (posRefStore[ric][rfid]!=undefined) {
//                                                             for (var ref in posRefStore[ric][rfid]) {
//                                                                 process(posRefStore[ric][rfid][ref], rfids[rfid], rfids, rfid);
//                                                             }
//                                                         }
//                                                     }

//                                                 }
//                                             }

//                                             if (riclist != "") {
//                                                 $.ajax({
//                                                     type: "GET",
//                                                     url: [APPPATH_DATA, "data/assetinfolistdata"].join(""),
//                                                     data: ["listtype=stock&subcat1=", riclist, "&subcat2=price"].join(""),
//                                                     success: function(response){
//                                                         var result = $.parseJSON(response);

//                                                         if (result.data && result.data.datalist && result.data.datalist.length > 0) {
//                                                             $.each(result.data.datalist, function(index, rowdata) {
//                                                                 if (rowdata) {
//                                                                     var ric=rowdata.ric;

//                                                                     for (var rtable in subranktables) {
//                                                                         if (subranktables[rtable] && subranktables[rtable][0]) {
//                                                                             var $rt = subranktables[rtable][0];
//                                                                             //find out the rank
//                                                                             var rank=$rt.listtable("getRowBySelector", ["[ric='", ric, "']"].join("")).find(".col_rank").text();

//                                                                             rowdata.rk=rank;
//                                                                             if (rowdata.fidmap) {
//                                                                                 rowdata.fidmap.rf1=$rt.listtable("getRowBySelector", ["[ric='", ric, "']"].join("")).find(".col_netchange").attr("fid");
//                                                                                 rowdata.fidmap.rf2=$rt.listtable("getRowBySelector", ["[ric='", ric, "']"].join("")).find(".col_pctchange").attr("fid");
//         //                                                                        rowdata.fidmap.rf1=$rt.listtable("getRowBySelector", ["[ric='", ric, "']"].join("")).find(".col_rf1").attr("fid");
//         //                                                                        rowdata.fidmap.rf2=$rt.listtable("getRowBySelector", ["[ric='", ric, "']"].join("")).find(".col_rf2").attr("fid");
//                                                                                 rowdata.fidmap.rf3=$rt.listtable("getRowBySelector", ["[ric='", ric, "']"].join("")).find(".col_rf3").attr("fid");
//                                                                             } else {
//                                                                                 rowdata.fidmap={
//                                                                                     ls: $rt.attr("lsfid"),
//                                                                                     op: $rt.attr("opfid"),
//                                                                                     hc: $rt.attr("hcfid"),
//                                                                                     hi: $rt.attr("hifid"),
//                                                                                     lo: $rt.attr("lofid"),
//                                                                                     tm: $rt.attr("tmfid"),
//                                                                                     rf1:$rt.attr("rf1fid"),
//                                                                                     rf2:$rt.attr("rf2fid"),
//                                                                                     rf3:$rt.attr("rf3fid")
//                                                                                     };
//                                                                             }

//                                                                             //replace original row
//                                                                             $rt.listtable("insertRowAtBySelector", ["[ric='", ric, "']"].join(""), rowdata, true);
//                                                                             stockinfo[ric]=rowdata;

//                                                                             $rt.listtable("getRowBySelector", ["[ric='", ric, "']"].join("")).find(".col").each(function() {
//                                                                                 var $this = $(this);
//                                                                                 var nric = $this.attr("ric");
//                                                                                 var nfid = $this.attr("fid");
//                                                                                 if (nric && nfid) {
//                                                                                     $this.addClass("stream flash");
//                                                                                     if (posRefStore[nric]==undefined) {
//                                                                                         posRefStore[nric]=[];
//                                                                                     }
//                                                                                     if (posRefStore[nric][nfid]==undefined) {
//                                                                                         posRefStore[nric][nfid]=[];
//                                                                                     }
//                                                                                     posRefStore[nric][nfid].push($this);
//                                                                                 }
//                                                                             });
//                                                                         }

//                                                                         }
//                                                                     }
//                                                             });
//                                                         }

// //                                                       for (var s in stockobj) {
// //                                                           for (var r in stockobj[s]) {
// //                                                              //console.log(stockobj[s][r].name);
// //                                                              stockinfo[r] = stockobj[s][r];
// //
// //                                                              $(".rstream[ric='" + robj.parent + "'] tr[ric='" + r + "'] #ric").each(function() {
// //                                                                  var cb = $(this).attr("callback");
// //                                                                  if (cb) {
// //                                                                      if (window[cb]) {
// //                                                                        $(this).empty().append(window[cb](stockobj[s][r].ticker, r, stockobj[s][r].name));
// //                                                                        $(this).attr("title", window[cb](stockobj[s][r].ticker, r, stockobj[s][r].name));
// //                                                                      }
// //                                                                  } else {
// //                                                                    $(this).empty().append(r);
// //                                                                    $(this).attr("title", r);
// //                                                                  }
// //                                                              });
// //
// //                                                              $(".rstream[ric='" + robj.parent + "'] tr[ric='" + r + "'] #name").each(function() {
// //                                                                  var cb = $(this).attr("callback");
// //                                                                  if (cb) {
// //                                                                      if (window[cb]) {
// //                                                                        $(this).empty().append(window[cb](stockobj[s][r].ticker, r, stockobj[s][r].name));
// //                                                                      }
// //                                                                  } else {
// //                                                                    $(this).empty().append(stockobj[s][r].name);
// //                                                                  }
// //                                                                  $(this).attr("title", stockobj[s][r].name);
// //                                                              });
// //
// //                                                              $(".rstream[ric='" + robj.parent + "'] tr[ric='" + r + "']").each(function() {
// //                                                                  var nbind = newrow.attr("bind");
// //                                                                  var nfn = newrow.attr("fn");
// //                                                                  if (nbind && nfn) {
// //                                                                      newrow.bind(nbind, {ric: r, name: stockobj[s][r].name}, window[nfn]);
// //                                                                  }
// //
// //                                                                  setCMData($(this), r, stockobj[s][r].ticker + " " + stockobj[s][r].name);
// //                                                              });
// //
// //                                                           }
// //                                                       }
//                                                     }
//                                                 });
//                                             }

// //                                                console.log("recycleObj");
// //                                                console.log(recycleObj);
//                                             for (var ro in recycleObj) {
//                                                 if (recycleObj[ro]!=null) {
//                                                     recycleObj[ro].find(".stream").each(function() {
//                                                         var $this = $(this);
//                                                         var r = $this.attr("ric");
//                                                         var f = $this.attr("fid");
//                                                         if (r && f) {
//                                                             desktop.unsubscribe(IDN_SERVICE, r);
// //                                                                console.log("streaming.js - stream: unsubscribe recycleobj ric " + r);
//                                                             if (f==6) {
//                                                                 desktop.unsubscribe(IDN_SERVICE, r);
// //                                                                    console.log("streaming.js - stream: unsubscribe recycleobj ric " + r + " due to fid 6");
//                                                             }
//                                                             if (posRefStore[r]!=undefined && posRefStore[r][f]!=undefined) {
//                                                                 for (var ref in posRefStore[r][f]) {
//                                                                     if (posRefStore[r][f][ref][0]===$this[0]) {
//                                                                         delete posRefStore[r][f][ref];
//                                                                     }
//                                                                 }
//                                                                 if (jQuery.isEmptyObject(posRefStore[r][f])) {
//                                                                     delete posRefStore[r][f];
//                                                                 }
//                                                                 if (jQuery.isEmptyObject(posRefStore[r])) {
//                                                                     delete posRefStore[r];
//                                                                 }
//                                                             }
//                                                         }
//                                                     });
//                                                 }
//                                             }
// //                                            console.log("recycleObj unsub finished");

//                                             recycleObj=null;
//                                         }
//                                     }
//                                 }
//                             }
//                         } else {

//                             var fids=rics[ric];
// //                            var items=$thisregion.find([".stream[ric='", ric, "']"].join(""));

//                             for (var fid in fids)
//                             {
// //                                items.filter(["[fid='", fid, "']"].join("")).each(function() {
// //                                    process($(this), fids[fid], items, fids, fid);
// //                                });

//                                 if (posRefStore[ric]!=undefined) {
//                                     // EITS 0017717: [Price Quote] China Index/Equity
//                                     // If 3372 fid existed and has valid value, call fid 6 to process once again
//                                     if (fid == 3372 && parseFloat(fids[3372])!=0 && (ric.endsWith(".SS") || ric.startsWith(".SSE") || ric=='.CSI300' || ric.endsWith(".TW") || ric=='.TWII' || ric.endsWith(".BK") || ric=='.SETI')) {
//                                       if (posRefStore[ric][6]!=undefined) {
//                                         for (var ref in posRefStore[ric][6]) {
//                                             process(posRefStore[ric][6][ref], fids[3372], fids, 6);
//                                         }
//                                       }
//                                     }
//                                     if (posRefStore[ric][fid]!=undefined) {
//                                         for (var ref in posRefStore[ric][fid]) {
//                                             process(posRefStore[ric][fid][ref], fids[fid], fids, fid);
//                                         }
//                                     }
//                                 }

//                                 // Handle Time & Sales
//                                 if (tsfid[ric]!=undefined && $.inArray(fid, tsfid[ric])>-1) {
//                                     //console.log("arrived ts fid " + fid);
//                                     if (tsFidValStore[ric]==undefined) {
//                                         tsFidValStore[ric]=[];
//                                     }
//                                     if (tsPrevFidValStore[ric]==undefined) {
//                                         tsPrevFidValStore[ric]=[];
//                                     }

//                                     var tsdata = fids[fid].split(";");
//                                     //console.log(fids[fid]);

//                                     for (var tsd in tsdata) {
//                                         //console.log(tsdata[tsd]);
//                                         if (tsdata[tsd].length == 0) continue;
//                                         var indtsd = tsdata[tsd].split(",");

//                                         tsFidValStore[ric]['time']=indtsd[0];
//                                         tsFidValStore[ric]['price']=indtsd[1];
//                                         tsFidValStore[ric]['volume']=indtsd[2];
//                                         tsFidValStore[ric]['accvol']=indtsd[3];
// //                          console.log("time: " + tsFidValStore[ric]['time'] + ", price: " + tsFidValStore[ric]['price'] + ", volume: " + tsFidValStore[ric]['volume'] + ", accvol: " + tsFidValStore[ric]['accvol']);
// //                          console.log("Previous accvol: " + tsPrevFidValStore[ric]['accvol']);

//                                         if (tsPrevFidValStore[ric]['accvol']==undefined) {
//                                             tsPrevFidValStore[ric]['accvol']=0;
//                                         }

//                                         if (parseInt(tsFidValStore[ric]['accvol'],10) > parseInt(tsPrevFidValStore[ric]['accvol'],10)) {
//                                             // add to the ts list
//                                             var $txdatalist = $([".txdatalist[ric='", ric, "']"].join(""));

//                                             var txrowdata = {
//                                                 PRICE: "",
//                                                 VOLUME: "",
//                                                 TIME: "",
//                                                 CHANGE: "",
//                                                 ACVOL: ""
//                                             };

//                                             var t=Date.parse(tsFidValStore[ric]['time']);
//                                             if (t) {
// //                                                if (typeof(timeoffset)=="undefined") timeoffset = boot.TZ_LOCAL_OFFSET;
// //                                                t.addHours(timeoffset);
//                                                 t.add(boot.TZ_LOCAL_OFFSET);
//                                                 txrowdata.TIME=t.toString(timefmt);
//                                             }

//                                             var txprice=tsFidValStore[ric]['price'];
//                                             var output=new NumberFormat();
//                                             output.setNumber(txprice);
//                                             txrowdata.PRICE=output.toFormatted();

//                                             if (parseFloat(tsFidValStore[ric]['price'], 10) > parseFloat(tsPrevFidValStore[ric]['price'], 10)) {
//                                                 txrowdata.CHANGE="1";
//                                             } else if (parseFloat(tsFidValStore[ric]['price'], 10) < parseFloat(tsPrevFidValStore[ric]['price'], 10)) {
//                                                 txrowdata.CHANGE="-1";
//                                             } else {
//                                                 txrowdata.CHANGE="0";
//                                             }

//                                             var txvolume=tsFidValStore[ric]['volume'];
//                                             output.setNumber(txvolume);
//                                             txrowdata.VOLUME=output.toFormatted();
//                                             txrowdata.ACVOL=tsFidValStore[ric]['accvol'];

//                                             $txdatalist.listtable("insertRowAt", 0, txrowdata, false);

//                                             tsPrevFidValStore[ric]['time']=tsFidValStore[ric]['time'];
//                                             tsPrevFidValStore[ric]['price']=tsFidValStore[ric]['price'];
//                                             tsPrevFidValStore[ric]['volume']=tsFidValStore[ric]['volume'];
//                                             tsPrevFidValStore[ric]['accvol']=tsFidValStore[ric]['accvol'];

//                                             //console.log("ADDED...:)");

//                                             if ($txdatalist.listtable("getRowCount")>5) {
//                                                 $txdatalist.listtable("removeRow", 5);
//                                             }

//                                             //console.log("REMOVED...>.<");
//                                             }
//                                         }
//                                     }

//                                 // Special handle - process fid value calculation
//                                 if (customFunc[ric]!=undefined && customFunc[ric][fid]!=undefined) {
//                                     if (fidValStore[ric]==undefined) {
//                                         fidValStore[ric]=[];
//                                     }
//                                     fidValStore[ric][fid]=fids[fid];
//                                     //console.log("fidValStore[" + ric + "][" + fid + "]: " + fidValStore[ric][fid])
//                                     //console.log(customFunc[ric][fid]);
//                                     var custFuncProcCnt=0;
//                                     for (var cidx in customFunc[ric][fid]) {
//                                         var fidAry = customFunc[ric][fid][cidx].fid;
//                                         //console.log(fidAry);
//                                         //console.log(customFunc[ric][fid][cidx]);
//                                         var param=[];
//                                         for (var n in fidAry) {
//                                             if (fidValStore[ric][fidAry[n]]!=undefined) {
//                                                 //                                param.push(parseFloat(fidValStore[ric][fidAry[n]]));
//                                                 param.push(fidValStore[ric][fidAry[n]]);
//                                             //console.log("push " + fidValStore[ric][fidAry[n]]);
//                                             }
//                                         }
//                                         if (fidAry.length == param.length) {
//                                             //console.log(cidx);
//                                             //console.log(customFunc[ric][fid][cidx]);
//                                             //console.log("process...");
//                                             //console.log(window[customFunc[ric][fid][cidx].func](param));
//                                             //console.log(customFunc[ric][fid][cidx].target);
//                                             custFuncProcCnt++;
//                                             param.push(ric);
//                                             if (window[customFunc[ric][fid][cidx].func]) {
//                                                 param.push(customFunc[ric][fid][cidx].target);
//                                                 //                              process(customFunc[ric][fid][cidx].target, window[customFunc[ric][fid][cidx].func](param)+"", service, ric, fids, fid);
//                                                 process(customFunc[ric][fid][cidx].target, window[customFunc[ric][fid][cidx].func](param, customFunc[ric][fid][cidx].ext)+"", fids, fid, true);
//                                             }
//                                         }
//                                     }
// //                      if (custFuncProcCnt==customFunc[ric][fid].length) {
// //                          fidValStore[ric]=[];
// //                      }
//                                 }
//                             }

//                         }
//                     }
//                 }
//                 else if (service == NEWS_SERVICE)
//                 {
//                     // For NEWS_SERVICE...
//                     if (queryStr != null)
//                     {
//                         var queries=data[desktop.NEWS_SERVICE];
//                         if (queries)
//                         {
//                             var headlines=queries[queryStr];
//                             if (headlines)
//                             {
//                                 for (var i=headlines.length-1;i>=0;i--)
//                                 {
//                                     var h=headlines[i];
//                                     var d=new Date(h[1015]);
//                                     var nid="urn:newsml:reuters.com:"+d.getUTCFullYear()+pad((d.getUTCMonth()+1))+pad(d.getUTCDate())+pad(d.getUTCHours())+pad(d.getUTCMinutes())+pad(d.getUTCSeconds())+ ":" + h[235];
// //                                    if (typeof(timeoffset)=="undefined") timeoffset = boot.TZ_LOCAL_OFFSET;
// //                                    d.addHours(timeoffset);
//                                     d.add(boot.TZ_LOCAL_OFFSET);

//                                     feednews(nid, h[725] + " - " + h[264], d);
//                                 }
//                             }
//                         }
//                     }
//                 }
//             }

//////var _et = $.now();
////////CONSOLELOGGER.info("Streaming.stream(" + JSON.stringify(data).length + "): " + (_et - _st));
//////CONSOLELOGGER.info("Streaming.stream(): " + (_et - _st));

        },
        subscribe : function(ricList,fidList) {

//////var _st = $.now();

            quoteinit(ricList,fidList);
            // rankinit(region);
            // tsinit(region);

            // region.data("issub", "true");
            
//////var _et = $.now();
//////CONSOLELOGGER.info("Streaming.subscribe(): " + (_et - _st));

        },
        unsubscribe : function(region, isPageObj) {

//////var _st = $.now();
            if (!isPageObj && region.data("issub")=="false") return;

            var $subregion = region;
            if (isPageObj) {
                $subregion = region.find(":data(issub)").filter(function() { return $(this).data("issub") === "true"; });
            }

            $subregion.find(".stream").each(function() {
                var $this = $(this);
//                var service=$this.attr("service");
                var ric=$this.attr("ric");
                var fid=$this.attr("fid");
                var id=$this.attr("id");
                if (ric && fid) {
                    if (!isNaN(fid)) {
                        desktop.unsubscribe(IDN_SERVICE, ric);
//                        console.log("streaming.js - unsubscribe: called unsubscribe ric: " + ric);
                        if (fid==6) {
                            desktop.unsubscribe(IDN_SERVICE, ric);
//                            console.log("streaming.js - unsubscribe: called unsubscribe ric: " + ric + " becoz of fid 6");
                        }
                    } else {
                        if (customFunc[ric]!=undefined) {
                            for (var f in customFunc[ric]) {
                                desktop.unsubscribe(IDN_SERVICE, ric);
                                for (var o in customFunc[ric][f]) {
                                    if (customFunc[ric][f][o].target[0]==$this[0]) {
                                        customFunc[ric][f].splice(o, 1);
                                    }
                                }
//                                console.log("streaming.js - unsubscribe: called unsubscribe customFunc ric: " + ric + " becoz of fid " + customFunc[ric][f]);
                            }
                        }
                    }
                    if (posRefStore[ric]!=undefined && posRefStore[ric][fid]!=undefined) {
                        for (var ref in posRefStore[ric][fid]) {
                            if (posRefStore[ric][fid][ref][0]===$this[0]) {
                                posRefStore[ric][fid][ref].removeClass("uptick downtick changed");
                                delete posRefStore[ric][fid][ref];
                            }
                        }
                        if (jQuery.isEmptyObject(posRefStore[ric][fid])) {
                            delete posRefStore[ric][fid];
                        }
                        if (jQuery.isEmptyObject(posRefStore[ric])) {
                            delete posRefStore[ric];
                        }
                    }
                } else if (ric && id) {
                    if (posRefStore[ric]!=undefined && posRefStore[ric][id]!=undefined) {
                        for (var ref in posRefStore[ric][id]) {
                            if (posRefStore[ric][id][ref][0]===$this[0]) {
                                delete posRefStore[ric][id][ref];
                            }
                        }
                        if (jQuery.isEmptyObject(posRefStore[ric][id])) {
                            delete posRefStore[ric][id];
                        }
                        if (jQuery.isEmptyObject(posRefStore[ric])) {
                            delete posRefStore[ric];
                        }
                    }
                }
            });
            if (region.is(".rstream")) {
                var chain=region.attr("chain");
                for (var n in subrankrics[chain]) {
                    desktop.unsubscribe(IDN_SERVICE, subrankrics[chain][n]);
//                    console.log("streaming.js - unsubscribe: called unsubscribe ranking ric: " + subrankrics[chain][n]);
                }
                subrankrics[chain]=[];
                subranktables[chain]=[];
                initrankrics[chain]=[];
                rankShowCounter[chain]=0;
            }
            region.find(".rstream").each(function() {
                var chain=$(this).attr("chain");
                for (var n in subrankrics[chain]) {
                    desktop.unsubscribe(IDN_SERVICE, subrankrics[chain][n]);
//                    console.log("streaming.js - unsubscribe: called unsubscribe ranking ric: " + subrankrics[chain][n]);
                }
                subrankrics[chain]=[];
                subranktables[chain]=[];
                initrankrics[chain]=[];
                rankShowCounter[chain]=0;
            });
            region.find(".txdatalist").each(function() {
                var $this = $(this);
                desktop.unsubscribe(IDN_SERVICE, $this.attr("ric"));
                delete tsfid[$this.attr("ric")];
            });

            $subregion.data("issub", "false");

//////var _et = $.now();
//////CONSOLELOGGER.info("Streaming.unsubscribe(): " + (_et - _st));

        },
        stop : function() {
            // Stop the update tick
            tickStarted = false;

            // Clean up...
            $(".stream").each(function() {
                var service=$(this).attr("service");
                var ric=$(this).attr("ric");
                if (service && ric) {
                    desktop.unsubscribe(service, ric);
                }
            });

            if (queryStr != null && queryStr!="") {
                desktop.unsubscribe(desktop.NEWS_SERVICE, queryStr);
            }

            for (var n in subrankrics) {
                if (subrankrics[n]) {
                    desktop.unsubscribe(IDN_SERVICE, subrankrics[n]); //TODO: not hardcode service
        //            console.log("unsubscribe ric: " + subrankrics[n]);
                }
            }

            for (var t in tsfid) {
                if (tsfid[t]) {
                    desktop.unsubscribe(IDN_SERVICE, tsfid[t]); //TODO: not hardcode service
                }
            }
        },
        unregister: function() {
            desktop.unregister(winId);
        },
        setTS: function(ric, fid, data) {
            if (tsPrevFidValStore[ric]==undefined) {
                tsPrevFidValStore[ric]=[];
            }
            tsPrevFidValStore[ric][fid] = data;
        }
    };
} ();

//################################################################################
//################################################################################
// Initialization / De-initiaization

export var $STREAMING_FRAME = null;

export function initStreaming(ispopoutmode) {
    // Started already?
    if ($STREAMING_FRAME) return;

    // Depending on the mode
    if (ispopoutmode) {
		alert("Streaming in popup window is NOT supported!");
    }
    else {
        // Register the root pageobj
        pages[root.id] = root;

        // With performance consideration, older IE will stream with a longer conflation time
        if (isConflate()) {
//        if (isMSIE_OLD()) {
            if (boot.conflate!=-1) {
                _STREAM_URL += "&conflate=" + boot.conflate;
            }
        }

        // Start the hidden streaming frame
        if (boot.FORCE_POLLING) $STREAMING_FRAME = $("<iframe/>").attr("id", "streaming").attr("src", "about:blank").hide();
                           else $STREAMING_FRAME = $("<iframe/>").attr("id", "streaming").attr("src", _STREAM_URL).hide();

        $body.append($STREAMING_FRAME);

        // Prepare the poll thread to start streaming
        if (si) {
            si.brokenPoll = true;
            si.abortPoll = false;
        }
        else {
            si = new StreamInfo(new Date().getTime());
        }

        // Start the command tick
        //si.lastTick=0;
        if (!cmdTickStarted) {
            cmdTickStarted = true;
            tick(); //setTimeout(tick, 1000);
        }
    }

    // Start streaming now :)
    Streaming.start();
}

export function stopStreaming() {
    // Stopped already?
    if (!$STREAMING_FRAME) return;

    // Stop the polling thread
    si.abortPoll = true;

    // Stop and clean up streaming stuffs...
    Streaming.stop();

//    // Stop the command tick
//    cmdTickStarted = false;

    // Drop the hidden streaming frame
    $STREAMING_FRAME.remove();
    $STREAMING_FRAME = null;
}


